import moment from 'moment-timezone'

import constants from '../constants.js'
import lodash from 'lodash'
import main from '../main'
import * as types from '@/store/types'
import { setupExperiments } from '@pizza-hut/lib-experiments/lib';
import CryptoJS from 'crypto-js';

const { Buffer } = require('buffer');

import PopupNotifyHut from '@/components/popup/PopupNotifyHut'

const TIMEZONE = 'Asia/Tokyo'
const UNIQUE_KEY_PROP = '__unique_key_prop__'
const KEY_PREFIX = '__key_prefix__' + Date.now() + '_'
let uid = 0
const isObject = val => val !== null && typeof val === 'object'
const genUniqueKey = obj => {
  if (isObject(obj)) {
    if (UNIQUE_KEY_PROP in obj) {
      return obj[UNIQUE_KEY_PROP]
    }
    const value = KEY_PREFIX + uid++
    Object.defineProperty(obj, UNIQUE_KEY_PROP, {value})
    return value
  }
  return obj
}

import ASAPPopup from '../components/popup/OrderASAP'

export default {
  data: function () {
    return {
      cart: {},
      disposition: {}
    }
  },
  methods: {
    genUniqueKey,
    isMobile: function () {
      return window.innerWidth <= 768
    },
    isMobileApp: function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    getWebOS: function () {
      const userAgent = navigator.userAgent
      if (/android/i.test(userAgent)) {
        return 'android'
      }
      if (/iPad|iPhone|iPod/i.test(userAgent)) {
        return 'ios'
      }
      return 'other'
    },
    /**
     * This function is same as PHP's nl2br() with default parameters.
     *
     * @param {string} str Input text
     * @param {boolean} replaceMode Use replace instead of insert
     * @param {boolean} isXhtml Use XHTML
     * @return {string} Filtered text
     */
    nl2brMethod (str, replaceMode, isXhtml) {
      let breakTag = (isXhtml) ? '<br />' : '<br>'
      let replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr)
    },
    /**
     * Get full url
     * */
    url: function (link) {
      return process.env.BASE_URL + '/' + link
    },
    /**
     * Redirect page
     * */
    redirect: function (url) {
      window.location.href = url
    },
    /**
     * Get current path
     * */
    getCurrentPath() {
      return window.location.pathname
    },
    /**
     * Checking has disposition
     * */
    checkPosition: function (vm) {
      return vm.$session.has('disposition') && vm.$session.get('disposition').outletId !== undefined
    },
    /**
     * Checking has disposition
     * */
    getOutletCode: function (vm) {
      let defaultStoreCode = vm.$session.get('defaultStoreCode') || constants.DEFAULT_OUTLET
      return vm.checkPosition(vm) ? vm.$session.get('disposition').outletCode : defaultStoreCode
    },
    /**
     * Check empty variable
     * */
    empty: function (param) {
      if (param == null) {
        return true
      }
      if (typeof param === 'object') {
        return Object.keys(param).length <= 0
      }

      if (typeof param === 'string') {
        return param.length <= 0
      }

      if (param instanceof Array) {
        return param.length <= 0
      }
      return false
    },
    /**
     * Get delivery info
     * */
    getDeliveryInfo(vm) {
      let disposition = vm.$session.has('disposition') ? vm.$session.get('disposition') : ''
      if (typeof disposition.outletId === 'undefined') return {orderType: '', addressInfo: ''}
      let strAddress = disposition.orderType == vm.$const.DELIVERY ? disposition.locationName : disposition.outletName
      if (typeof strAddress === 'undefined' || !strAddress) {
        return {orderType: '', addressInfo: ''}
      }
      let addressInfo = strAddress
      let orderType = disposition.orderType == vm.$const.DELIVERY ? vm.$const.DELIVERY.toLowerCase() : vm.$const.CARRYOUT.toLowerCase()
      let info = {orderType, addressInfo}
      return info
    },
    convertDateTimeToUTC(datetime) {
      if (!datetime) {
        return moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }

      let chkdate = moment(datetime)
      if (!chkdate.isValid()) {
        return moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      return chkdate.utc().format('YYYY-MM-DD HH:mm:ss')
    },
    convertUTCToClientTime(datetime) {
      if (!datetime) {
        return ''
      }
      return moment.utc(datetime).local()
    },
    convertUTCToTimeZone(datetime, timezone) {
      if (!datetime) {
        return moment.utc(new Date()).tz(timezone)
      }
      return moment.utc(datetime).tz(timezone)
    },
    convertDateTimeFromTimezoneToUTC(timezone, datetime) {
      if (!timezone) {
        return this.convertDateTimeToUTC(datetime)
      }
      if (!datetime) {
        return moment.tz(timezone).utc().format('YYYY-MM-DD HH:mm:ss')
      }

      let chkdate = moment.tz(datetime, timezone)
      if (!chkdate.isValid()) {
        return moment.tz(timezone).utc().format('YYYY-MM-DD HH:mm:ss')
      }
      return chkdate.utc().format('YYYY-MM-DD HH:mm:ss')
    },
    convertToUTCIfHasTimezone(vm, datetime) {
      let disposition = vm.$session.get('disposition')
      let timezone = false
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        timezone = disposition['timezone']
      }
      if (!timezone) {
        return this.convertDateTimeToUTC(datetime)
      }
      return this.convertDateTimeFromTimezoneToUTC(timezone, datetime)
    },
    convertToUTCIfHasTimezoneNoTime(vm, datetime) {
      let data = this.convertToUTCIfHasTimezone(vm, datetime)
      if (data) {
        data = data.split(' ')[0]
      }
      return data
    },
    getCurrentDateLocal() {
      return moment(new Date()).format('YYYY-MM-DD')
    },
    /**
     * Get collection time (client timezone)
     * Show on header main and checkout page
     * */
    getTimePicker(vm, isHtml = false) {
      let disposition = vm.$session.get('disposition')
      let collectionTime = false
      let timezone = false
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        collectionTime = disposition['collectionTime']
        timezone = disposition['timezone']
      }

      let today = !timezone ? moment(new Date()).format('YYYY-MM-DD') : moment.tz(timezone).format('YYYY-MM-DD')
      let nextday = !timezone ? moment(new Date()).add(1, 'days').format('YYYY-MM-DD') : moment.tz(timezone).add(1, 'days').format('YYYY-MM-DD')
      let pickedDay = collectionTime ? collectionTime.pickedDay : ''
      let pickedHours = collectionTime ? collectionTime.pickedHours : ''
      let result = ''
      let isAsap = false

      if (!vm.$session.has('disposition') || (disposition['advanceOrder'] === 'undefined' || disposition['advanceOrder'] == 0 || disposition['advanceOrder'] == '')) {
        result = vm.$t('asap_1') || ''
        isAsap = true
      } else if (pickedDay == today) {
        result = vm.$t('today') || ''
      } else if (pickedDay == nextday) {
        result = vm.$t('tomorrow') || ''
      } else {
        result = collectionTime.pickedDay
      }

      if (isHtml) {
        result = '<span class="text-nowrap">' + result + '</span>' + (this.isMobile() ? '<br>' : '')
      }

      if (!isAsap) {
        if (isHtml) {
          result += '<span class="text-nowrap">' + pickedHours + '</span>'
        } else {
          result += ' ' + pickedHours
        }
      }

      return result
    },
    /**
     *
     * Get collection time (client timezone)
     * To pass ordertime to api (cart api)
     * return YYYY-MM-DD HH:mm:ss
     * */
    getTimePickerDate(vm) {
      let disposition = vm.$session.get('disposition')
      let today = moment(new Date()).format('YYYY-MM-DD')
      let collectionTime = today + ' ' + moment(new Date()).format('HH:mm')
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        collectionTime = disposition['collectionTimeValue'] + ':00'
        let timezone = disposition['timezone']
        if (disposition['advanceOrder'] === 'undefined' || disposition['advanceOrder'] == 0 || disposition['advanceOrder'] == '') {
          return moment.tz(timezone).local().format('YYYY-MM-DD HH:mm:ss')
        }
        let datatime = moment.tz(collectionTime, timezone)
        if (datatime.isValid) {
          return datatime.local().format('YYYY-MM-DD HH:mm:ss')
        }
      }
      if (!vm.$session.has('disposition')) {
        collectionTime = today + ' ' + moment(new Date()).format('HH:mm:ss')
      }
      return collectionTime
    },
    getTimePickerDateNoneConvert(vm) {
      let disposition = vm.$session.get('disposition')
      let collectionTime = moment(new Date())
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        collectionTime = disposition['collectionTimeValue'] + ':00'
        let timezone = disposition['timezone']
        if (disposition['advanceOrder'] === 'undefined' || disposition['advanceOrder'] == 0 || disposition['advanceOrder'] == '') {
          return moment.tz(timezone)
        }
        let datatime = moment.tz(collectionTime, timezone)
        if (datatime.isValid) {
          return datatime
        }
      }
      if (!this.$session.has('disposition')) {
        collectionTime = moment(new Date())
      }
      return collectionTime
    },
    /**
     * Get payment name
     * */
    getPaymentName(val) {
      let name = ''
      switch (val) {
        case 7:
          name = 'Creadit Card'
          break
        case 5:
          name = 'Maybank2U'
          break
        case 9:
          name = 'Cash'
          break
        case 4:
          name = 'Master Card'
          break
      }
      return name
    },
    /**
     * Convert string to Capitalize Case
     *
     * Ex:
     *    INPUT: 'sample String  test    foo   bar  '
     *    OUTPUT: 'Sample String Test Foo Bar'
     * */
    convertString(str) {
      if (typeof str === undefined || typeof str === 'undefined' || str.length <= 0) {
        return ''
      }

      // START <space> sanitizer
      const regxReduceSpace = /\s{2,}/gi
      while (regxReduceSpace.test(str)) {
        str = str.replace(regxReduceSpace, ' ')
      }
      str = str.trim()
      // END ./ <space> sanitizer

      let arrstr = str.split(' ')
      let result = ''
      for (var val in arrstr) {
        var lowstr = arrstr[val].toLowerCase()
        var upstr = lowstr.charAt(0).toUpperCase() + lowstr.slice(1)
        result += upstr + ' '
      }
      return result.trim()
    },
    /**
     * Convert string to snake-case
     *
     * Ex:
     *    INPUT: 'sample String  test    foo   bar  '
     *    OUTPUT: 'sample-string-test-foo-bar'
     * */
    convertStringSnakeCase(str) {
      if (typeof str === undefined || typeof str === 'undefined' || str.length <= 0) {
        return ''
      }

      // START <space> sanitizer
      const regxReduceSpace = /\s{2,}/gi
      while (regxReduceSpace.test(str)) {
        str = str.replace(regxReduceSpace, ' ')
      }
      str = str.trim()
      // END ./ <space> sanitizer

      let arrstr = str.split(' ')
      let result = ''

      arrstr.forEach((val, i) => {
        var lowstr = arrstr[i].toLowerCase()

        // add '-' character, except for LAST WORD of string
        if (i < arrstr.length - 1) {
          result += lowstr + '-'
        } else {
          result += lowstr
        }
      })

      return result.trim()
    },
    /**
     * Format number
     * */
    formatNum(num) {
      num = num || 0
      return parseFloat(Math.round(num * 100) / 100).toFixed(constants.CURRENCY_FORMAT)
    },
    /**
     * Format number
     * */
    formatNumDisplay(num) {
      num = num || 0
      return parseFloat(Math.round(num * 100) / 100).toFixed(constants.CURRENCY_FORMAT).replace(constants.CURRENCY_RGX, constants.CURRENCY_DEC_POINT)
    },
    formatNumDisplayUpRound(num) {
      num = num || 0
      return parseFloat(Math.ceil(num * 100) / 100).toFixed(constants.CURRENCY_FORMAT).replace(constants.CURRENCY_RGX, constants.CURRENCY_DEC_POINT)
    },
    formatNumDisplayDownRound(num) {
      num = num || 0
      return parseFloat(Math.floor((num * 100) / 100)).toFixed(constants.CURRENCY_FORMAT).replace(constants.CURRENCY_RGX, constants.CURRENCY_DEC_POINT)
    },
    formatNum2Fix(num) {
      num = num || 0
      return parseFloat(Math.round(num * 100) / 100).toFixed(2)
    },
    checkNum(num) {
      return parseFloat(num || 0)
    },
    // sumNum (num1, num2) {
    //   num1 = parseFloat(num1 || 0)
    //   num2 = parseFloat(num2 || 0)
    //   let num = num1 + num2
    //   return (Math.round(num * 100) / 100).toFixed(2)
    // },
    sumNum(num1, num2, num3) {
      num1 = parseFloat(num1 || 0)
      num2 = parseFloat(num2 || 0)
      num3 = parseFloat(num3 || 0)
      let num = num1 + num2 + num3
      return (Math.round(num * 100) / 100).toFixed(constants.CURRENCY_FORMAT)
    },
    sumNumWithoutFormat(num1, num2) {
      num1 = parseFloat(num1 || 0)
      num2 = parseFloat(num2 || 0)
      let num = num1 + num2
      return Math.round(num * 100) / 100
    },
    clearNotification(vm, group) {
      group = group || ''
      vm.$notify({
        group: group,
        clean: true
      })
    },
    /**
     * Format number
     * */
    formatPercent(num) {
      return parseFloat(Math.round(num * 100) / 100).toFixed(0)
    },
    validName (name) {
      let re = /髙|﨑|德|濵|彅|郞/
      return !re.test(name)
    },
    validJPNumber (number) {
      let re = /Ⅰ|Ⅱ|Ⅲ|Ⅳ|Ⅴ|Ⅵ|Ⅶ|Ⅷ|Ⅸ|Ⅹ|Ⅺ|Ⅻ|ⅰ|ⅱ|ⅲ|ⅳ|ⅴ|ⅵ|ⅶ|ⅷ|ⅸ|ⅹ|ⅺ|ⅻ/
      return !re.test(number)
    },
    /**
     * Checking valid email field
     * @param email
     * @returns {boolean}
     */
    validEmail (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.){1,126}){1}(?:(?:[a-zA-Z][a-zA-Z0-9]*)|(?:(?:xn--)[a-zA-Z0-9]+))(?:-{1,63}[a-zA-Z0-9]+)*)))$/
      return re.test(email)
    },
    validEmailNotRFC(email){
      let re = /^[^@]*@[^@]*$/
      return re.test(email)
    },
    getUserDatalayer(vm) {
      let userinfo = vm.$auth.check() ? vm.$auth.user() : {}
      let user = {
        'status': !this.empty(userinfo) ? 'logged-in' : 'logged-out',
        'customer': {
          'id': !this.empty(userinfo) ? (!this.empty(userinfo.wos_id) ? userinfo.wos_id : userinfo.uuid) : '',
          'status': !this.empty(userinfo) && ((userinfo.outlets != null && userinfo.outlets.length > 0) || (userinfo.locations != null && userinfo.locations.length)) ? 'repeat' : 'new',
          'external_id': !this.empty(userinfo) ? CryptoJS.SHA256(userinfo.email).toString(CryptoJS.enc.Hex) : '',
        },
        'device': {
          'typeRollup': this.isMobile() ? 'mobile' : 'desktop'
        }
      }
      return user
    },
    getFlatformDatalayer(vm) {
      let flatform = vm.$const.DATA_LAYER.PLATFORM
      flatform.environment = process.env.NODE_ENV
      flatform.localeLanguage = vm.$i18n.locale
      return flatform
    },
    /**
     * tracking all page
     * @param vm
     * @param pageInfo is a object includes name and type
     *  sample { 'name': 'homepage.home',  'type': 'homepage'}
     * @param isNoLoad
     */
    eventTrackingScreenLoad(vm, pageInfo, isNoLoad = false) {
      console.info('+++++++++++++eventTrackingScreenLoad++++++++++++++')
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': pageInfo.screen,
        'platform': this.getFlatformDatalayer(vm),
        'user': {}
      }
      if (isNoLoad) {
        data.event = 'screen.noLoad.auto.dataLayer.noLoad'
      }
      if (pageInfo.modules) {
        data.modules = pageInfo.modules
      }
      if (pageInfo.assets) {
        data.assets = pageInfo.assets
      }
      data.user = this.getUserDatalayer(vm)
      console.info('+++++++++++++eventTrackingScreenLoad data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingScreenLoad end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     * tracking success localizaion
     */
    eventTrackingLocalisationSuccess(vm) {
      console.info('+++++++++++++eventTrackingLocalisationSuccess++++++++++++++')
      let data = {
        'event': 'user.interact.auto.success.localisationSuccess',
        'cart': this.generateCartBasic(vm)
      }
      console.info('+++++++++++++eventTrackingLocalisationSuccess data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingLocalisationSuccess end ++++++++++++++')
      dataLayer.push(data)
    },

    eventTrackingLocalisationError (data) {
      console.info('+++++++++++++eventTrackingLocalisationError++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.error.localisationError',
        'error': {
          'code': data.code,
          'type': 'geolocation',
          'error': data.error
        }
      }
      console.info('+++++++++++++eventTrackingLocalisationError data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingLocalisationError end ++++++++++++++')
      dataLayer.push(layer)
    },
    /**
     * @param items is list of products
     */
    eventTrackingProductLoad(vm, items, isHalf = false, isList = false) {
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      let productids = []
      let products = []
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      if (isHalf) {
        console.info('+++++++++++++eventTrackingProductLoad half ++++++++++++++')
        productids.push(vm.$const.HALF_HALF_UUID)
        products.push({
          'id': vm.$const.HALF_HALF_UUID,
          'name': this.convertStringSnakeCase(items.name_en || items.name),
          'category': 'pizza',
          'variants': [],
          'value': {
            'displayGross': '0',
            'displayTax': '0'
          },
          'tax': {
            'type': '',
            'name': '',
            'size': ''
          },
          'purchaseMethod': 'main',
          'bundleItems': []
        })
      } else {
        if (!isList) {
          console.info('+++++++++++++eventTrackingProductLoad menu single ++++++++++++++')
          productids.push(items.uuid)
          products.push({
            id: items.uuid,
            name: this.convertStringSnakeCase(items.name_en || items.name),
            category: this.getNameCategoryCurrent(items),
            variants: [],
            value: {
              displayGross: items.price,
              displayTax: 0
            },
            tax: {
              type: '',
              name: '',
              size: ''
            },
            purchaseMethod: 'main',
            bundleItems: []
          })
        } else {
          console.info('+++++++++++++eventTrackingProductLoad list ++++++++++++++')
          if (items && items.length > 0) {
            for (let i in items) {
              let menus = items[i].singles
              if (menus.length > 0) {
                for (let m in menus) {
                  productids.push(menus[m].uuid)
                  products.push({
                    id: menus[m].uuid,
                    name: this.convertStringSnakeCase(menus[m].name_en || menus[m].name),
                    category: this.getNameCategoryCurrent(menus[m]),
                    variants: [],
                    value: {
                      displayGross: menus[m].price,
                      displayTax: 0
                    },
                    tax: {
                      type: '',
                      name: '',
                      size: ''
                    },
                    purchaseMethod: 'main',
                    bundleItems: []
                  })
                }
              }
            }
          }
        }
      }
      let layer = {
        'event': 'product.load.auto.dataLayer.load',
        'products': productids,
        'assets': {
          'products': products
        }
      }
      console.info('+++++++++++++eventTrackingProductLoad data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingProductLoad end ++++++++++++++')
      dataLayer.push(layer)
    },
    /**
     * the event is used for
     * 1 Combo detail: product detail page
     * 2 menu or half & half: product list page ( include all of crust and size)
     * 3 menu or half & half detail page: already add to cart
     * @param item is a product
     */
    eventTrackingProductDetail(vm, item, type, nameType = 'product-list', hideEvent = false, method = 'main') {
      console.info('+++++++++++++eventTrackingProductDetail ++++++++++++++')
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let cart = this.generateCartBasic(vm, true)
      let variants = []
      let name = ''
      if (type != vm.$const.CARD_ITEM_TYPE.HALF) {
        if (item) {
          if (item.first_layers) {
            for (let f in item.first_layers) {
              let price = item.first_layers[f].price
              if (item.first_layers[f].second_layers != null && item.first_layers[f].second_layers.length > 0) {
                for (let s in item.first_layers[f].second_layers) {
                  price = item.first_layers[f].price + item.first_layers[f].second_layers[s].price
                  variants.push({
                    id: item.first_layers[f].uuid + '-' + item.first_layers[f].second_layers[s].uuid,
                    name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name} ${item.first_layers[f].second_layers[s].name}`),
                    type: 'size-crust',
                    quantity: 1,
                    value: {
                      displayGross: price,
                      displayTax: 0
                    }
                  })
                }
              } else {
                variants.push({
                  id: item.first_layers[f].uuid,
                  name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name}`),
                  type: 'size',
                  quantity: 1,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
            }
          }
          name = nameType + '.' + cateogry.slug + '.'
          let _tempMode = item.isMultiple ? 'multiple-item' : 'single-item'
          if (type == vm.$const.CARD_ITEM_TYPE.COMBO) {
            name += _tempMode + '.'
          }
          if (method === 'deal') {
            name = nameType + '.' + cateogry.slug + '.' + _tempMode + '.' + (item.comboName ? item.comboName.split(' ').join('-') : item.comboName) + '.'
          }
          name += item.name ? item.name.split(' ').join('-') : item.name
        }
      } else {
        name = nameType + '.pizza.half-and-half'
        item = {
          id: item.uuid || vm.$const.HALF_HALF_UUID,
          uuid: item.uuid || vm.$const.HALF_HALF_UUID,
          name: vm.convertStringSnakeCase(item.name_en || item.name),
          price: 0,
          isHalf: item.isHalf || false
        }
      }
      let flatform = vm.$const.DATA_LAYER.PLATFORM
      flatform.environment = process.env.NODE_ENV
      flatform.localeLanguage = vm.$i18n.locale

      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': {
          'name': name,
          'type': nameType
        },
        'platform': flatform,
        'user': {},
        'products': [item.uuid],
        'cart': cart,
        'assets': {
          'products': [{
            id: item.uuid,
            name: this.convertStringSnakeCase(item.name_en || item.name),
            category: this.getNameCategoryCurrent(item),
            attributes: {},
            variants: variants,
            'value': {
              'displayGross': item.price,
              'displayTax': 0
            },
            'tax': {
              'type': '',
              'name': '',
              'size': 0
            },
            'purchaseMethod': method
          }]
        }
      }
      data.user = this.getUserDatalayer(vm)
      if (hideEvent) {
        delete data.event
      }
      console.info('+++++++++++++eventTrackingProductDetail data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingProductDetail end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     *
     */
    eventTrackingProductView(variantUUid = null, product = {}, vm = null) {
      console.info('+++++++++++++eventTrackingProductView data ++++++++++++++')
      let products = []
      let item = product.item || product
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let category = {}
      let categories = vm.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            category = categories[i]
            break
          }
        }
        if (this.empty(category)) {
          category = categories[0]
        }
      }
      if (product && vm && product != {} && vm != null) {
        let bundleItems = []
        for (let i in product.combogroup) {
          let menu = product.combogroup[i].item
          let variantOb = {
            quantity: 1,
            'value': {
              'displayGross': 0,
              'displayTax': 0
            }
          }
          let price = menu.price
          let nameMenu = menu.name
          if (menu.hasOwnProperty('choosedFirst') && menu.choosedFirst != null && !vm.empty(menu.choosedFirst)) {
            variantOb.id = menu.choosedFirst.uuid
            variantOb.value.displayGross += menu.choosedFirst.price
            price -= menu.choosedFirst.price
            variantOb.name = menu.name
            if (variantOb.name.indexOf(menu.choosedFirst.name) >= 0) {
              variantOb.name = variantOb.name.replace(menu.choosedFirst.name, '').trim()
              nameMenu = variantOb.name
            }
            variantOb.name += '-' + menu.choosedFirst.name
            variantOb.type = 'size'
          }
          if (menu.hasOwnProperty('choosedSecond') && menu.choosedSecond != null && !vm.empty(menu.choosedSecond)) {
            variantOb.name += '-' + menu.choosedSecond.name
            variantOb.id += '-' + menu.choosedSecond.uuid
            variantOb.type += '-crust'
            variantOb.value.displayGross += menu.choosedSecond.price
            price -= menu.choosedSecond.price
          }

          variantOb.name = this.convertStringSnakeCase(variantOb.name)
          bundleItems.push({
            productId: menu.uuid,
            category: category.name || '', // not yet from api
            quantity: '1',
            name: this.convertStringSnakeCase(nameMenu),
            purchaseMethod: 'deal',
            variant: variantOb,
            value: {
              displayGross: price,
              displayTax: 0
            }
          })
        }
        products.push({
          'id': item.uuid,
          'name': this.convertStringSnakeCase(item.name_en || item.name),
          'category': this.getNameCategoryCurrent(item),
          'attributes': {},
          'variants': [],
          'value': {
            'displayGross': product.price,
            'displayTax': '0.00'
          },
          'tax': {
            'type': '',
            'name': '',
            'size': ''
          },
          'purchaseMethod': 'main',
          'bundleItems': bundleItems
        })
      }

      let categoryName = this.getNameCategoryCurrent(item)
      let name = this.convertStringSnakeCase(item.name_en || item.name) || ''
      const layer = {
        'event': 'product.interact.manual.view',
        'variantId': variantUUid || '',
        'products': [
          item.uuid
        ],
        'name': name,
        'id': item.uuid || '',
        'category': categoryName || '',
        'price': item.min_price || '0',
        'assets': {
          'products': products
        }
      }
      console.info('+++++++++++++eventTrackingProductView data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingProductView end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingAddToCart(vm, item, method = 'main', type = '', interaction = 'direct-product-selection') {
      console.info('+++++++++++++eventTrackingAddToCart ++++++++++++++')
      let _menu = item.item
      let variants = []
      if (_menu) {
        if (_menu.first_layers) {
          for (let f in _menu.first_layers) {
            let _price = _menu.first_layers[f].price
            if (_menu.first_layers[f].second_layers != null && _menu.first_layers[f].second_layers.length > 0) {
              for (let s in _menu.first_layers[f].second_layers) {
                _price = _menu.first_layers[f].price + _menu.first_layers[f].second_layers[s].price
                variants.push({
                  id: _menu.first_layers[f].uuid + '-' + _menu.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${_menu.name} ${_menu.first_layers[f].name} ${_menu.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: _price,
                    displayTax: 0
                  }
                })
              }
            } else {
              variants.push({
                id: _menu.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${_menu.name} ${_menu.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: _price,
                  displayTax: 0
                }
              })
            }
          }
        }
      }
      let categoryName = this.getNameCategoryCurrent(_menu)
      const name = this.convertStringSnakeCase(_menu.name_en || _menu.name) || ''
      let layer = {
        'event': 'product.interact.manual.click.addToCart',
        'user.customer.id': vm.$auth.check() ? (!this.empty(vm.$auth.user().wos_id) ? vm.$auth.user().wos_id : '') : '',
        'cart_id': (vm.cart && vm.cart.uuid) || '',
        'interactionElement': interaction,
        'bundleItems': [],
        'productId': '',
        'variantId': item.variant_uuid || '',
        'name': name,
        'id': _menu.uuid || '',
        'category': categoryName || '',
        'price': _menu.min_price || '0',
        'quantity': '1',
        'context': item.context,
        'assets': {
          'products': [
            {
              'id': _menu.uuid || '',
              'name': name,
              'category': categoryName || '',
              'attributes': {},
              'variants': variants,
              'value': {
                'displayGross': _menu.min_price || '0',
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main'
            }
          ]
        }
      }
      switch (type) {
        case vm.$const.CARD_ITEM_TYPE.SINGLE:
          layer.productId = item.id
          if (typeof item.first !== 'undefined' && !vm.empty(item.first)) {
            layer.variantId = item.first.uuid
            if (typeof item.second !== 'undefined' && !vm.empty(item.second)) {
              layer.variantId += '-' + item.second.uuid
            }
          }
          break
        case vm.$const.CARD_ITEM_TYPE.COMBO:
          layer.productId = item.id
          layer.products = {
            id: item.id,
            name: this.convertStringSnakeCase(_menu.name_en || _menu.name),
            category: categoryName || '', // not yet from api
            purchaseMethod: 'deal',
            value: {
              displayGross: item.price,
              displayTax: 0
            },
            bundleItems: {}
          }
          let bundleItems1 = []
          for (let i in item.items) {
            let menu = item.items[i]
            let variantOb = {
              quantity: 1,
              'value': {
                'displayGross': 0,
                'displayTax': 0
              }
            }
            let price = menu.item.price
            let nameMenu = menu.item.name
            if (menu.hasOwnProperty('first') && menu.first != null && !vm.empty(menu.first)) {
              variantOb.id = menu.first.uuid
              // price += menu.first.price
              variantOb.value.displayGross += menu.first.price
              variantOb.name = menu.item.name
              if (variantOb.name.indexOf(menu.first.name) >= 0) {
                variantOb.name = variantOb.name.replace(menu.first.name, '').trim()
                nameMenu = variantOb.name
              }
              variantOb.name += '-' + menu.first.name
              variantOb.type = 'size'
            }
            if (menu.hasOwnProperty('second') && menu.second != null && !vm.empty(menu.second)) {
              variantOb.name += '-' + menu.second.name
              variantOb.id += '-' + menu.second.uuid
              variantOb.type += '-crust'
              // price += menu.second.price
              variantOb.value.displayGross += menu.second.price
            }

            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems1.push({
              productId: menu.item.uuid,
              category: menu.item.category || '',
              quantity: '1',
              name: this.convertStringSnakeCase(nameMenu),
              purchaseMethod: 'deal',
              variant: variantOb,
              value: {
                displayGross: price,
                displayTax: 0
              }
            })
          }
          layer.bundleItems = bundleItems1
          layer.products.bundleItems = bundleItems1
          break
        case vm.$const.CARD_ITEM_TYPE.HALF:
          layer.productId = item.id
          let bundleItems = []
          for (let i in item.items) {
            let menu = item.items[i]
            let variantOb = {
              quantity: 1,
              'value': {
                'displayGross': 0,
                'displayTax': 0
              }
            }
            let price = menu.item.price
            if (menu.hasOwnProperty('first') && menu.first != null) {
              variantOb.id = menu.first.uuid
              // price += menu.first.price
              variantOb.name = menu.item.name + '-' + menu.first.name
              variantOb.type = 'size'
              variantOb.value.displayGross += menu.first.price
            }
            if (menu.hasOwnProperty('second') && menu.second != null) {
              variantOb.name += '-' + menu.second.name
              variantOb.id += '-' + menu.second.uuid
              variantOb.type += '-crust'
              // price += menu.second.price
              variantOb.value.displayGross += menu.second.price
            }

            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems.push({
              productId: menu.item.uuid,
              category: menu.item.category || '', // not yet from api
              quantity: '1',
              name: this.convertStringSnakeCase(menu.item.name),
              purchaseMethod: 'half-half',
              variant: variantOb,
              value: {
                displayGross: price,
                displayTax: 0
              }
            })
          }
          layer.bundleItems = bundleItems
          break
      }
      console.info('+++++++++++++eventTrackingAddToCart data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingAddToCart end ++++++++++++++')
      if (vm.cart.uuid) {
        dataLayer.push(layer)
      } else {
        setTimeout(function () {
          let cartInfo = vm.$cart.get(vm)
          layer.cart_id = cartInfo.uuid || ''
          dataLayer.push(layer)
        }, 3000)
      }
    },
    evenTrackingProductClick(vm, item, method = '', type = 1) {
      let variants = []
      if (item) {
        if (item.first_layers) {
          for (let f in item.first_layers) {
            let price = item.first_layers[f].price
            if (item.first_layers[f].second_layers != null && item.first_layers[f].second_layers.length > 0) {
              for (let s in item.first_layers[f].second_layers) {
                price = item.first_layers[f].price + item.first_layers[f].second_layers[s].price
                variants.push({
                  id: item.first_layers[f].uuid + '-' + item.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name} ${item.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
            } else {
              variants.push({
                id: item.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: price,
                  displayTax: 0
                }
              })
            }
          }
        }
      }
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (item.item && item.item.category) {
        cateogry = vm._.cloneDeep(item.item.category)
        let lang = vm.$i18n ? vm.$i18n.locale || vm.$const.LANG_JP : vm.$const.LANG_JP
        if (cateogry.name && cateogry.name[lang] != undefined) {
          cateogry.name = cateogry.name[lang]
        } else {
          cateogry = {}
        }
      }

      if (vm.empty(cateogry) && categories.length > 0 ) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let data = {
        'event': 'product.interact.manual.click',
        'interactionElement': {
          'method': method
        },
        'products': [item.uuid],
        'productId': item.uuid,
        'variantId': item.variant_uuid || '',
        'assets': {
          'products': [
            {
              'id': item.uuid || '',
              'name': this.convertStringSnakeCase(item.name_en || item.name) || '',
              'category': this.getNameCategoryCurrent(item),
              'attributes': {},
              'variants': variants,
              'value': {
                'displayGross': item.min_price || '0',
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main'
            }
          ]
        }
      }
      console.info('+++++++++++++evenTrackingProductClick data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++evenTrackingProductClick end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingAddToDeal(vm, item) {
      console.info('+++++++++++++eventTrackingAddToDeal ++++++++++++++')
      let variants = []
      if (typeof item.first !== 'undefined' && !vm.empty(item.first)) {
        let variant = {}
        let price = item.first.price
        variant.id = item.first.uuid
        variant.name = this.convertStringSnakeCase(`${item.name} ${item.first.name}`)
        variant.type = 'size'
        if (typeof item.second !== 'undefined' && !vm.empty(item.second)) {
          variant.id += '-' + item.second.uuid
          variant.type += '-crust'
          variant.name += '-' + item.second.name
          price += item.second.price
        }

        variant.value = {
          displayGross: price,
          displayTax: 0
        }
        variant.name = this.convertStringSnakeCase(variant.name)
        variants.push(variant)
      }
      let menu = item.item
      let variantsData = []
      if (menu) {
        if (menu.first_layers) {
          for (let f in menu.first_layers) {
            let price1 = menu.first_layers[f].price
            if (menu.first_layers[f].second_layers != null && menu.first_layers[f].second_layers.length > 0) {
              for (let s in menu.first_layers[f].second_layers) {
                price1 = menu.first_layers[f].price + menu.first_layers[f].second_layers[s].price
                variantsData.push({
                  id: menu.first_layers[f].uuid + '-' + menu.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${menu.name} ${menu.first_layers[f].name} ${menu.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: price1,
                    displayTax: 0
                  }
                })
              }
            } else {
              variantsData.push({
                id: menu.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${menu.name} ${menu.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: price1,
                  displayTax: 0
                }
              })
            }
          }
        }
      }
      let data = {
        'event': 'product.interact.manual.click',
        'interactionMethod': 'add-to-deal',
        'products': [{
          'id': item.combo_uuid,
          'bundleItems': [
            {
              'id': item.id,
              'name': this.convertStringSnakeCase(menu.name_en || menu.name) || '',
              'category': this.getNameCategoryCurrent(item),
              'attributes': {},
              'variants': variants,
              'value': {
                'displayGross': item.price,
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'deal'
            }
          ]
        }],
        'assets': {
          'products': [
            {
              'id': menu.uuid || '',
              'name': this.convertStringSnakeCase(menu.name_en || menu.name) || '',
              'category': this.getNameCategoryCurrent(item),
              'attributes': {},
              'variants': variantsData,
              'value': {
                'displayGross': menu.min_price || '0',
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main'
            }
          ]
        }
      }
      console.info('+++++++++++++eventTrackingAddToDeal data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingAddToDeal end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingRemoveFromCart(item) {
      console.info('+++++++++++++eventTrackingRemoveFromCart++++++++++++++')
      let categoryUuid = this.$session.get('categoryUuid') || this.$store.getters.category_uuid
      let cateogry = {}
      let categories = this.$session.get('listCategory')
      if (item && item.category) {
        cateogry = this.lodash.cloneDeep(item.category)
        let lang = this.$i18n ? this.$i18n.locale || this.$const.LANG_JP : this.$const.LANG_JP
        if (cateogry.name && cateogry.name[lang] != undefined) {
          cateogry.name = cateogry.name[lang]
        } else {
          cateogry = {}
        }
      }
      if (this.empty(cateogry) && categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let categoryName = this.getNameCategoryFromCart(item)
      let name = this.convertStringSnakeCase(item.name_en || item.name) || ''
      if (item.half_half_id) {
        name = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0) == 'D' ? this.$const.HALF_HALF_30_NAME : this.$const.HALF_HALF_50_NAME
      }
      let data = {
        'event': 'product.interact.manual.click.removeFromCart',
        'product': {
          'id': item.id,
          'variants': item.variants,
          'quantity': item.quantity
        },
        'id': item.id,
        'variants': item.variants,
        'name': name,
        'category': categoryName || '',
        'price': item.price || '0'
      }
      console.info('+++++++++++++eventTrackingRemoveFromCart data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingRemoveFromCart end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingUpdateQuantityFromCart(item, vm = null) {
      console.info('+++++++++++++addToCart++++++++++++++')
      let data = {
        'event': 'product.interact.manual.click.addToCart',
        'user.customer.id': vm.$auth.check() ? (!this.empty(vm.$auth.user().wos_id) ? vm.$auth.user().wos_id : '') : '',
        'cart_id': (vm.cart && vm.cart.uuid) || '',
        'interactionElement': {'method': 'quantity-increase'},
        'productId': item.id,
        'variantId': item.variantId,
        'quantity': item.quantity
      }
      console.info('+++++++++++++addToCart data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++addToCart end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     * @param variant is a menu
     *  {
          "id": "crispy-bacon",
          "productId": "pepperoni-feast",
          "type": "topping",
          "name": "crispy-bacon",
          "value": {
            "displayGross": "1.20",
            "displayTax": "0.24"
          }
        }
     */
    eventTrackingVariantSelect(item) {
      console.info('+++++++++++++eventTrackingVariantSelect ++++++++++++++')
      let topping = item.topping
      let first = item.first
      let price = 0
      if (topping) {
        price = topping.prices != null && topping.prices.hasOwnProperty(first.sku) ? topping.prices[first.sku] : 0
      } else {
        price = 0
      }

      let data = {
        'event': 'variant.interact.manual.click.select',
        'variant': {
          'id': topping ? topping.uuid : '',
          'productId': item.item ? item.item.uuid : '',
          'type': 'topping',
          'name': topping ? this.convertStringSnakeCase(topping.name) : '',
          'value': {
            'displayGross': price,
            'displayTax': '0'
          }
        }
      }
      console.info('+++++++++++++eventTrackingVariantSelect data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingVariantSelect end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     * @param variant is a menu
     *  {
          "id": "crispy-bacon",
          "productId": "pepperoni-feast",
          "type": "topping",
          "name": "crispy-bacon",
          "value": {
            "displayGross": "1.20",
            "displayTax": "0.24"
          }
        }
     */
    eventTrackingVariantUnSelect(item) {
      console.info('+++++++++++++eventTrackingVariantUnSelect++++++++++++++')
      let topping = item.topping
      let first = item.first
      let price = 0
      if (topping) {
        price = topping.prices != null && topping.prices.hasOwnProperty(first.sku) ? topping.prices[first.sku] : 0
      } else {
        price = 0
      }
      let data = {
        'event': 'variant.interact.manual.click.unselect',
        'variant': {
          'id': topping ? topping.uuid : '',
          'productId': item.item ? item.item.uuid : '',
          'type': 'topping',
          'name': topping ? topping.name : '',
          'value': {
            'displayGross': price,
            'displayTax': '0'
          }
        }
      }
      console.info('+++++++++++++eventTrackingVariantUnSelect data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingVariantUnSelect end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingCheckout(vm) {
      console.info('+++++++++++++eventTrackingCheckout++++++++++++++')
      let cart = this.generateCartFullForCheckout(vm)
      cart.checkoutStep = 1
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': {
          'name': 'checkout.details',
          'type': 'checkout'
        },
        'cart': cart,
        'user': this.getUserDatalayer(vm),
        'platform': this.getFlatformDatalayer(vm)
      }
      console.info('+++++++++++++eventTrackingCheckout data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingCheckout end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingPayment(vm, form) {
      console.info('+++++++++++++eventTrackingPayment ++++++++++++++')
      let cart = this.generateCartFullForCheckout(vm)
      cart.checkoutStep = 2
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': {
          'name': 'checkout.payment',
          'type': 'checkout'
        },
        'forms': [form.id],
        'cart': cart,
        'assets': form
      }
      console.info('+++++++++++++eventTrackingPayment data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingPayment end ++++++++++++++')
      dataLayer.push(data)
    },
    getCategoryNameFromOrder (item) {
      let category = item.display_category_en || ''
      category = category.toLowerCase()
      return category.replace(/\s/g, '')
    },
    /**
     * for order status page
     * @param data
     * @param orderTime
     * @returns {{id: string, checkoutStep: string, currency: *, discount: {lines: Array, value: {displayGross: *, displayTax: string}}, shipping: {value: {displayGross: *, displayTax: string}, type: string, storeId: *, deliveryTime: *}, value: {displayGross: number | string | * | PaymentItem, displayTax: number}}}
     */
    genCartForConfirmation(vm, data, orderTime) {
      let cart = {
        'id': data.cart_uuid,
        'currency': data.currency,
        'lines': [],
        'discount': {
          lines: [],
          value: {
            'displayGross': data.total_discount, // total discount
            'displayTax': '0.00'
          }
        },
        'shipping': {
          'value': {
            'displayGross': data.delivery_fee || 0,
            'displayTax': '0.00'
          },
          'type': data.order_type.toUpperCase() == 'D' ? vm.$const.DELIVERY.toLowerCase() : 'collection',
          'storeId': data.outlet_code,
          'deliveryTime': orderTime
        },
        'value': {
          'displayGross': data.total || 0, // total cart
          'displayTax': 0
        }
      }
      for (let i in data.order_items) {
        let menu = vm._.cloneDeep(data.order_items[i])
        let item = {}
        let categoryName = this.getCategoryNameFromOrder(menu)
        if (menu.type == vm.$const.CARD_ITEM_TYPE.COMBO) {
          item.id = data.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': menu.uuid || 0,
            'name': this.convertStringSnakeCase(menu.name_en || menu.name),
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.price || 0,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          let bundleItems = []
          for (let c in menu.items) {
            let product = vm._.cloneDeep(menu.items[c])
            let variantOb = {
              'value': {
                'displayGross': 0,
                'displayTax': '0'
              }
            }
            let fPrice = 0
            if (product.hasOwnProperty('first') && product.first != null && product.first.sku != '') {
              variantOb.id = product.first.uuid
              fPrice += product.first.price
              variantOb.name = product.name + '-' + product.first.name
              variantOb.type = 'size'
              if (product.first.hasOwnProperty('second') && product.first.second != null && product.first.second.sku != '') {
                variantOb.id = product.first.uuid + '-' + product.first.second.uuid
                variantOb.name += '-' + product.first.second.name
                variantOb.type += '-crust'
                fPrice += product.first.second.price
              }
            }
            variantOb.value.displayGross = fPrice
            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems.push({
              productId: product.uuid,
              category: (product.base_category && product.base_category.short_name) || '',
              quantity: product.quantity,
              name: this.convertStringSnakeCase(product.name),
              purchaseMethod: 'deal',
              variant: variantOb,
              value: {
                displayGross: product.base_price || 0,
                displayTax: 0
              }
            })
          }
          item.product.bundleItems = bundleItems
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          if (menu.coupon_code != undefined && menu.coupon_code != null && !this.empty(menu.coupon_code)) {
            item.discount.lines.push(this.getCoupondetail2(menu.coupon_code, data.order_coupons))
          }
          let dprice = 0
          for (let d in item.discount.lines) {
            dprice += parseFloat(item.discount.lines[d].value.displayGross)
          }
          item.discount.value.displayGross = dprice
        } else if (menu.type == vm.$const.CARD_ITEM_TYPE.SINGLE) {
          item.id = data.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': '',
            'name': '',
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.price || 0,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          for (let v in menu.items) {
            if (v == 0) {
              item.product.id = menu.items[v].uuid
              item.product.name = this.convertStringSnakeCase(menu.items[v].name_en || menu.items[v].name)
            }
            if (menu.items[v].coupon_code != undefined && menu.items[v].coupon_code != null && !this.empty(menu.items[v].coupon_code)) {
              item.discount.lines.push(this.getCoupondetail2(menu.items[v].coupon_code, data.order_coupons))
            }
            if (typeof menu.items[v].first !== 'undefined' && !this.empty(menu.items[v].first) && menu.items[v].first.sku != '') {
              let variant = {}
              let price = menu.items[v].first.price
              variant.id = menu.items[v].first.uuid
              variant.name = menu.items[v].name + '-' + menu.items[v].first.name
              variant.type = 'size'
              if (typeof menu.items[v].first.second !== 'undefined' && !this.empty(menu.items[v].first.second) && menu.items[v].first.second.sku != '') {
                variant.type += '-crust'
                variant.name += '-' + menu.items[v].first.second.name
                price += menu.items[v].first.second.price
                variant.id = menu.items[v].first.uuid + '-' + menu.items[v].first.second.uuid
              }
              variant.value = {
                displayGross: price,
                displayTax: 0
              }
              variant.name = this.convertStringSnakeCase(variant.name)
              item.product.variants.push(variant)
            }
          }
          let dprice = 0
          for (let d in item.discount.lines) {
            dprice += parseFloat(item.discount.lines[d].value.displayGross)
          }
          item.discount.value.displayGross = dprice
        } else if (menu.type == vm.$const.CARD_ITEM_TYPE.HALF) {
          item.id = data.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': vm.$const.HALF_HALF_UUID,
            'name': vm.convertStringSnakeCase(menu.name_en || menu.name),
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.price || 0,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          if (menu.only_lunch) {
            item.product.id = vm.$const.HALF_HALF_LUNCH_UUID
          }
          let bundleItems = []
          for (let v in menu.items) {
            if (typeof menu.items[v].coupon_code != 'undefined' && menu.items[v].coupon_code != null && !this.empty(menu.items[v].coupon_code)) {
              item.discount.lines.push(this.getCoupondetail2(menu.items[v].coupon_code, data.order_coupons))
            }
            let _menu = vm._.cloneDeep(menu.items[v])
            let layerInfo = vm._.cloneDeep(_menu)
            let variantOb = {
              quantity: 1,
              'value': {
                'displayGross': 0,
                'displayTax': 0
              }
            }
            let price = _menu.base_price || 0
            if (layerInfo.hasOwnProperty('first') && layerInfo.first != null && layerInfo.first.sku != '') {
              variantOb.id = layerInfo.first.uuid
              // price += layerInfo.first.price
              variantOb.name = _menu.name + '-' + layerInfo.first.name
              variantOb.type = 'size'
              variantOb.value.displayGross += layerInfo.first.price
              if (layerInfo.first.hasOwnProperty('second') && layerInfo.first.second != null && layerInfo.first.second.sku != '') {
                variantOb.name += '-' + layerInfo.first.second.name
                variantOb.id += '-' + layerInfo.first.second.uuid
                variantOb.type += '-crust'
                // price += layerInfo.first.second.price
                variantOb.value.displayGross += layerInfo.first.second.price
              }
            }

            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems.push({
              productId: _menu.uuid,
              category: _menu.category || '', // not yet from api
              quantity: '1',
              name: this.convertStringSnakeCase(_menu.name),
              purchaseMethod: 'half-half',
              variant: variantOb,
              value: {
                displayGross: price,
                displayTax: 0
              }
            })
          }
          item.product.bundleItems = bundleItems
          let dprice = 0
          for (let d in item.discount.lines) {
            dprice += parseFloat(item.discount.lines[d].value.displayGross)
          }
          item.discount.value.displayGross = dprice
        }
        cart.lines.push(item)
      }

      if (data.order_coupons) {
        for (let c in data.order_coupons) {
          if (data.order_coupons[c].type != vm.$const.COUPON_TYPE_ITEM) {
            cart.discount.lines.push({
              id: data.order_coupons[c].coupon_uuid,
              name: this.convertStringSnakeCase(data.order_coupons[c].coupon_name),
              code: data.order_coupons[c].coupon_code,
              type: data.order_coupons[c].discount_type_name,
              size: data.order_coupons[c].discount_percent_unit || 0,
              value: {
                'displayGross': data.order_coupons[c].discount,
                'displayTax': '0.00'
              }
            })
          }
        }
      }
      return cart
    },
    eventTrackingConfirmation(vm, cart) {
      console.info('+++++++++++++eventTrackingConfirmation ++++++++++++++')
      let timezone = cart.timezone
      let orderTime = this.convertUTCToTimeZone(cart.collection_time, timezone)
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'user': this.getUserDatalayer(vm),
        'screen': {
          'name': 'checkout.confirmation',
          'type': 'checkout'
        },
        'transaction': {
          id: cart.uuid,
          currency: cart.currency,
          cart: this.genCartForConfirmation(vm, cart, orderTime.unix()),
          value: {
            'displayGross': cart.total || 0,
            'displayTax': 0
          },
          payment: {
            id: cart.order_payment.id,
            authId: '',
            type: cart.order_payment.method,
            timestamp: orderTime.unix()
          }
        }
      }
      console.info('+++++++++++++eventTrackingConfirmation data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingConfirmation end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingOrderSubmit(id) {
      let data = {
        'event': 'cart.interact.manual.submit.orderSubmit',
        'cart': id
      }
      dataLayer.push(data)
    },
    eventTrackingOrderError(data) {
      console.info('+++++++++++++eventTrackingOrderError ++++++++++++++')
      let layer = {
        'event': 'cart.load.auto.error.orderError',
        'cart': {
          'id': data.id
        },
        'error': {
          'code': data.code,
          'type': data.type,
          'message': data.message
        }
      }
      console.info('+++++++++++++eventTrackingOrderError data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingOrderError end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingContactus(contactus) {
      console.info('+++++++++++++eventTrackingContactus ++++++++++++++')
      let data = {
        'screen': {
          'name': 'contact-us.contact-us',
          'type': 'contact-us'
        },
        'forms': [
          contactus.id
        ],
        'assets': {
          'forms': [
            contactus
          ]
        }
      }
      console.info('+++++++++++++eventTrackingContactus data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingContactus end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     *
     * @param data
     */
    eventTrackingModuleLoad(data) {
      console.info('+++++++++++++eventTrackingModuleLoad ++++++++++++++')
      let layer = {
        'event': 'module.load.auto.dataLayer.load',
        'module': {
          'id': data.id,
          'name': data.name,
          'type': data.type,
          'placement': data.placement,
          'items': data.items || []
        },
        'assets': data.assets || {}
      }
      console.info('+++++++++++++eventTrackingModuleLoad data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingModuleLoad end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingCoupon(vm, data) {
      vm.$cart.init(vm)
      console.info('+++++++++++++eventTrackingCoupon++++++++++++++')
      let layer = {
        'event': 'cart.interact.manual.submit.promoCodeAdded',
        'discountLine': {
          'cartId': vm.cart.uuid || 0,
          'id': 'cart-disc-123',
          'name': data.name,
          'type': 'fixed',
          'size': data.price,
          'value': {
            'displayGross': data.price,
            'displayTax': '0.00'
          },
          'code': data.couponCode,
          'category': 'listed'
        }
      }
      console.info('+++++++++++++eventTrackingCoupon data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingCoupon end ++++++++++++++')
      dataLayer.push(layer)
    },
    /**
     *
     * @param data
     */
    eventTrackingModuleItemClick(data) {
      console.info('+++++++++++++eventTrackingModuleItemClick data ++++++++++++++')
      let layer = {
        'event': 'moduleItem.interact.manual.click',
        'moduleItem': {
          'id': data.id,
          'moduleId': data.moduleId
        }
      }
      console.info('+++++++++++++eventTrackingModuleItemClick data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingModuleItemClick end ++++++++++++++')
      dataLayer.push(layer)
    },
    getCoupondetail(code, data) {
      let coupon = {}
      for (let c1 in data) {
        if (data[c1].code == code) {
          coupon = {
            id: data[c1].coupon_uuid,
            name: this.convertStringSnakeCase(data[c1].name),
            type: data[c1].discount_type_name,
            size: data[c1].discount_percent_unit || 0,
            'value': {
              'displayGross': data[c1].discount_value,
              'displayTax': '0'
            },
            code: data[c1].code
          }
          break
        }
      }
      return coupon
    },
    getCoupondetail2(code, data) {
      let coupon = {}
      for (let c1 in data) {
        if (data[c1].coupon_code == code) {
          coupon = {
            id: data[c1].coupon_uuid,
            name: this.convertStringSnakeCase(data[c1].coupon_name),
            type: data[c1].discount_type_name,
            size: data[c1].discount_percent_unit || 0,
            'value': {
              'displayGross': data[c1].discount,
              'displayTax': '0'
            },
            code: data[c1].coupon_code
          }
          break
        }
      }
      return coupon
    },
    generateCartFullForCheckout(vm) {
      let cart = {}
      try {
        vm.$cart.init(vm)
        cart = {
          'id': vm.cart.uuid,
          'currency': vm.$const.CURRENCY_CODE,
          'shipping': {
            'value': {
              'displayGross': vm.cart.delivery_fee || 0,
              'displayTax': '0.00'
            },
            'discount': {},
            'type': vm.$disposition.getByKey(vm, 'orderType', '').toLowerCase() == vm.$const.DELIVERY.toLowerCase() ? vm.$const.DELIVERY.toLowerCase() : 'collection',
            'storeId': vm.$disposition.getByKey(vm, 'outletCode', ''),
            'deliveryTime': this.getTimePickerDateNoneConvert(vm).unix()
          },
          'value': {
            'displayGross': vm.cart.total || 0,
            'displayTax': 0
          }
        }
        cart.lines = []
        for (let i in vm.cart.data) {
          let menu = vm._.cloneDeep(vm.cart.data[i])
          let item = {}
          let menuCategory = this.getNameCategoryFromCart(menu)
          if (menu.product_type == vm.$const.CARD_ITEM_TYPE.COMBO) {
            item.id = vm.cart.uuid + '-' + (parseFloat(i) + 1)
            item.product = {
              'id': menu.combo_uuid,
              'name': this.convertStringSnakeCase(menu.name_en || menu.name),
              'category': menuCategory,
              'attributes': {},
              'variants': [],
              'value': {
                'displayGross': menu.item_price || 0,
                'displayTax': '0'
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main',
              'bundleItems': []
            }
            item.quantity = menu.quantity
            item.value = {
              'displayGross': menu.total,
              'displayTax': '0'
            }
            item.discount = {
              lines: [],
              'value': {
                'displayGross': '',
                'displayTax': '0'
              }
            }
            if (menu.coupon_code != null && !this.empty(menu.coupon_code)) {
              item.discount.lines.push(this.getCoupondetail(menu.coupon_code, vm.cart.coupon.data))
            }
            let bundleItems = []
            for (let c in menu.items) {
              for (let j in menu.items[c].group_items) {
                let layerInfo = vm._.cloneDeep(menu.items[c].group_items[j].layer_info)
                let variantOb = {
                  quantity: 1,
                  'value': {
                    'displayGross': '0',
                    'displayTax': '0'
                  }
                }
                let price = 0
                if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
                  price = layerInfo.first.price
                  variantOb.id = layerInfo.first.uuid
                  variantOb.name = menu.items[c].group_items[j].name + '-' + layerInfo.first.name
                  variantOb.type = 'size'
                }
                if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
                  variantOb.id += '-' + layerInfo.second.uuid
                  variantOb.name += '-' + layerInfo.second.name
                  variantOb.type += '-crust'
                  price += layerInfo.second.price
                }
                variantOb.value.displayGross = price
                variantOb.name = this.convertStringSnakeCase(variantOb.name)
                bundleItems.push({
                  productId: menu.items[c].group_items[j].product_uuid,
                  category: (menu.items[c].group_items[j].base_category && menu.items[c].group_items[j].base_category.short_name) || '',
                  quantity: '1',
                  name: this.convertStringSnakeCase(menu.items[c].group_items[j].name),
                  purchaseMethod: 'deal',
                  variants: [variantOb],
                  value: {
                    displayGross: menu.items[c].group_items[j].base_price || 0,
                    displayTax: 0
                  }
                })
              }
            }
            item.product.bundleItems = bundleItems
          } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.SINGLE) {
            item.id = vm.cart.uuid + '-' + (parseFloat(i) + 1)
            item.product = {
              'id': '',
              'name': '',
              'category': menuCategory,
              'attributes': {},
              'variants': [],
              'value': {
                'displayGross': menu.item_price || 0,
                'displayTax': '0'
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main',
              'bundleItems': []
            }
            item.quantity = menu.quantity
            item.value = {
              'displayGross': menu.total,
              'displayTax': '0'
            }
            item.discount = {
              lines: [],
              'value': {
                'displayGross': '',
                'displayTax': '0'
              }
            }
            if (menu.coupon_code != null && !this.empty(menu.coupon_code)) {
              item.discount.lines.push(this.getCoupondetail(menu.coupon_code, vm.cart.coupon.data))
            }
            for (let v in menu.items) {
              if (v == 0) {
                item.product.id = menu.items[v].product_uuid
                item.product.name = this.convertStringSnakeCase(menu.items[v].name_en || menu.items[v].name)
              }
              if (typeof menu.items[v].layer_info.first !== 'undefined' && !vm.empty(menu.items[v].layer_info.first)) {
                let variant = {}
                let price = menu.items[v].layer_info.first.price
                variant.id = menu.items[v].layer_info.first.uuid
                variant.name = menu.items[v].name + '-' + menu.items[v].layer_info.first.name
                variant.type = 'size'
                if (typeof menu.items[v].layer_info.second !== 'undefined' && !vm.empty(menu.items[v].layer_info.second)) {
                  variant.type += '-crust'
                  variant.name += '-' + menu.items[v].layer_info.second.name
                  price += menu.items[v].layer_info.second.price
                  variant.id += '-' + menu.items[v].layer_info.second.uuid
                }
                variant.value = {
                  displayGross: price,
                  displayTax: 0
                }
                variant.name = this.convertStringSnakeCase(variant.name)
                item.product.variants.push(variant)
              }
            }
          } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.HALF) {
            item.id = vm.cart.uuid + '-' + (parseFloat(i) + 1)
            item.product = {
              'id': vm.$const.HALF_HALF_UUID,
              'name': vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0) == 'D' ? vm.$const.HALF_HALF_30_NAME : vm.$const.HALF_HALF_50_NAME,
              'category': menuCategory,
              'attributes': {},
              'variants': [],
              'value': {
                'displayGross': menu.item_price || 0,
                'displayTax': '0'
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main',
              'bundleItems': []
            }
            if (menu.only_lunch) {
              item.product.id = vm.$const.HALF_HALF_LUNCH_UUID
            }
            item.quantity = menu.quantity
            item.value = {
              'displayGross': menu.total,
              'displayTax': '0'
            }
            item.discount = {
              lines: [],
              'value': {
                'displayGross': '',
                'displayTax': '0'
              }
            }
            let bundleItems = []
            for (let i in menu.items) {
              let _menu = vm._.cloneDeep(menu.items[i])
              let layerInfo = vm._.cloneDeep(_menu.layer_info)
              let variantOb = {
                quantity: 1,
                'value': {
                  'displayGross': 0,
                  'displayTax': 0
                }
              }
              let price = _menu.base_price || 0
              if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
                variantOb.id = layerInfo.first.uuid
                variantOb.name = _menu.name + '-' + layerInfo.first.name
                variantOb.type = 'size'
                variantOb.value.displayGross += layerInfo.first.price
              }
              if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
                variantOb.name += '-' + layerInfo.second.name
                variantOb.id += '-' + layerInfo.second.uuid
                variantOb.type += '-crust'
                variantOb.value.displayGross += layerInfo.second.price
              }

              variantOb.name = this.convertStringSnakeCase(variantOb.name)
              bundleItems.push({
                productId: _menu.product_uuid,
                category: _menu.category || '', // not yet from api
                quantity: '1',
                name: this.convertStringSnakeCase(_menu.name),
                purchaseMethod: 'half-half',
                variant: variantOb,
                value: {
                  displayGross: price,
                  displayTax: 0
                }
              })
            }
            item.product.bundleItems = bundleItems
            if (menu.coupon_code != null && !this.empty(menu.coupon_code)) {
              item.discount.lines.push(this.getCoupondetail(menu.coupon_code, vm.cart.coupon.data))
            }
          }
          cart.lines.push(item)
        }
        cart.discount = {
          lines: [],
          value: {
            'displayGross': '0.00',
            'displayTax': '0.00'
          }
        }
        if (vm.cart.coupon) {
          cart.discount.value.displayGross = vm.cart.coupon.total_discount

          for (let c in vm.cart.coupon.data) {
            if (vm.cart.coupon.data[c].discount_type != vm.$const.COUPON_TYPE_ITEM) {
              cart.discount.lines.push({
                id: vm.cart.coupon.data[c].coupon_uuid,
                name: this.convertStringSnakeCase(vm.cart.coupon.data[c].name),
                code: vm.cart.coupon.data[c].code,
                type: vm.cart.coupon.data[c].discount_type_name,
                size: vm.cart.coupon.data[c].discount_percent_unit || 0,
                value: {
                  'displayGross': vm.cart.coupon.data[c].discount_value,
                  'displayTax': '0.00'
                }
              })
            }
          }
        }
      } catch (error) {
        console.error('Error generateCartFullForCheckout')
      }
      return cart
    },
    generateCartBasic(vm, includeProducts, includeDiscount) {
      let cart = {}
      try {
        vm.$cart.init(vm)
        let cartData = vm._.cloneDeep(vm.cart)
        cart = {
          'id': cartData.uuid,
          'currency': vm.$const.CURRENCY_CODE,
          'shipping': {
            'value': {
              'displayGross': cartData.delivery_fee || 0,
              'displayTax': '0.00'
            },
            'discount': {},
            'type': vm.$disposition.getByKey(vm, 'orderType', '').toLowerCase() == vm.$const.DELIVERY.toLowerCase() ? vm.$const.DELIVERY.toLowerCase() : 'collection',
            'storeId': vm.$disposition.getByKey(vm, 'outletCode', ''),
            'deliveryTime': this.getTimePickerDateNoneConvert(vm).unix()
          },
          'value': {
            'displayGross': cartData.total || 0,
            'displayTax': cartData.tax_total || 0
          }
        }
        if (includeProducts) {
          cart.lines = []
          for (let i in cartData.data) {
            let menu = vm._.cloneDeep(cartData.data[i])
            let item = {
              id: cartData.uuid + '-' + (parseFloat(i) + 1),
              product: {},
              quantity: menu.quantity,
              value: {
                'displayGross': menu.total,
                'displayTax': 0
              }
            }
            let menuCategory = this.getNameCategoryFromCart(menu)
            if (menu.product_type == vm.$const.CARD_ITEM_TYPE.COMBO) {
              let bundleItems = []
              item.product.id = menu.combo_uuid
              item.product.name = this.convertStringSnakeCase(menu.name_en || menu.name) || ''
              item.product.category = menuCategory || '',
              item.product.attributes = {}
              item.product.purchaseMethod = 'main'
              item.product.bundleItems = []
              item.product.tax = {
                'type': '',
                'name': '',
                'size': ''
              }
              item.product.value = {
                displayGross: menu.item_price,
                displayTax: 0
              }
              item.product.variants = []
              for (let c in menu.items) {
                for (let j in menu.items[c].group_items) {
                  let layerInfo = vm._.cloneDeep(menu.items[c].group_items[j].layer_info)
                  let variantOb = {
                    quantity: 1,
                    'value': {
                      'displayGross': 0,
                      'displayTax': 0
                    }
                  }
                  if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
                    variantOb.id = layerInfo.first.uuid
                    variantOb.name = menu.items[c].group_items[j].name + '-' + layerInfo.first.name
                    variantOb.type = 'size'
                    variantOb.value.displayGross += layerInfo.first.price
                  }
                  if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
                    variantOb.name += '-' + layerInfo.second.name
                    variantOb.id += '-' + layerInfo.second.uuid
                    variantOb.type += '-crust'
                    variantOb.value.displayGross += layerInfo.second.price
                  }

                  variantOb.name = this.convertStringSnakeCase(variantOb.name)
                  bundleItems.push({
                    productId: menu.items[c].group_items[j].product_uuid,
                    category: (menu.items[c].group_items[j].base_category && menu.items[c].group_items[j].base_category.short_name) || '',
                    quantity: '1',
                    name: this.convertStringSnakeCase(menu.items[c].group_items[j].name),
                    purchaseMethod: 'deal',
                    variant: variantOb,
                    value: {
                      displayGross: menu.items[c].group_items[j].base_price || 0,
                      displayTax: 0
                    }
                  })
                }
              }
              item.product.bundleItems = bundleItems
            } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.SINGLE) {
              item.product.id = ''
              item.product.name = this.convertStringSnakeCase(menu.name_en || menu.name) || ''
              item.product.category = menuCategory || '',
              item.product.attributes = {}
              item.product.purchaseMethod = 'main'
              item.product.bundleItems = []
              item.product.tax = {
                'type': '',
                'name': '',
                'size': ''
              }
              item.product.value = {
                displayGross: menu.item_price,
                displayTax: 0
              }
              item.product.variants = []
              let datamenu = vm._.cloneDeep(menu.items)
              for (let v in datamenu) {
                if (v == 0) {
                  item.product.id = datamenu[v].product_uuid
                  item.product.name = this.convertStringSnakeCase(datamenu[v].name_en || datamenu[v].name)
                }
                let layerInfo = vm._.cloneDeep(datamenu[v].layer_info)

                if (typeof layerInfo.first !== 'undefined' && !vm.empty(layerInfo.first)) {
                  let variant = {}
                  let price = layerInfo.first.price
                  variant.id = layerInfo.first.uuid
                  variant.name = datamenu[v].name + '-' + layerInfo.first.name
                  variant.type = 'size'
                  if (typeof layerInfo.second !== 'undefined' && !vm.empty(layerInfo.second)) {
                    variant.type += '-crust'
                    variant.name += '-' + layerInfo.second.name
                    price += layerInfo.second.price
                    variant.id += '-' + layerInfo.second.uuid
                  }
                  variant.value = {
                    displayGross: price,
                    displayTax: 0
                  }
                  variant.name = this.convertStringSnakeCase(variant.name)
                  item.product.variants.push(variant)
                }
              }
            } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.HALF) {
              item.product.id = ''
              item.product.name = vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0) == 'D' ? vm.$const.HALF_HALF_30_NAME : vm.$const.HALF_HALF_50_NAME,
              item.product.category = menuCategory || '',
              item.product.attributes = {}
              item.product.purchaseMethod = 'main'
              item.product.bundleItems = []
              item.product.tax = {
                'type': '',
                'name': '',
                'size': ''
              }
              item.product.value = {
                displayGross: menu.item_price,
                displayTax: 0
              }
              item.product.variants = []
              item.product.id = vm.$const.HALF_HALF_UUID
              if (menu.only_lunch) {
                item.product.id = vm.$const.HALF_HALF_LUNCH_UUID
              }
              let bundleItems = []
              let datamenu = vm._.cloneDeep(menu.items)
              for (let i in datamenu) {
                let _menu = vm._.cloneDeep(datamenu[i])
                let layerInfo = vm._.cloneDeep(_menu.layer_info)
                let variantOb = {
                  quantity: 1,
                  'value': {
                    'displayGross': 0,
                    'displayTax': 0
                  }
                }
                let price = _menu.base_price || 0
                if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
                  variantOb.id = layerInfo.first.uuid
                  variantOb.name = _menu.name + '-' + layerInfo.first.name
                  variantOb.type = 'size'
                  variantOb.value.displayGross += layerInfo.first.price
                }
                if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
                  variantOb.name += '-' + layerInfo.second.name
                  variantOb.id += '-' + layerInfo.second.uuid
                  variantOb.type += '-crust'
                  variantOb.value.displayGross += layerInfo.second.price
                }

                variantOb.name = this.convertStringSnakeCase(variantOb.name)
                bundleItems.push({
                  productId: _menu.product_uuid,
                  category: _menu.category || '', // not yet from api
                  quantity: '1',
                  name: this.convertStringSnakeCase(_menu.name_en || _menu.name),
                  purchaseMethod: 'half-half',
                  variant: variantOb,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
              item.product.bundleItems = bundleItems
            }
            cart.lines.push(item)
          }
        }
        if (includeDiscount) {
          cart.discount = {
            lines: [],
            value: {
              'displayGross': '0.00',
              'displayTax': '0.00'
            }
          }
          if (cartData.coupon) {
            cart.discount.value.displayGross = cartData.coupon.total_discount

            for (let c in cartData.coupon.data) {
              if (cartData.coupon.data[c].discount_type != vm.$const.COUPON_TYPE_ITEM) {
                cart.discount.lines.push({
                  id: cartData.coupon.data[c].code,
                  name: this.convertStringSnakeCase(cartData.coupon.data[c].name),
                  code: cartData.coupon.data[c].code,
                  type: 'fixed',
                  size: cartData.coupon.data[c].discount_value,
                  value: {
                    'displayGross': cartData.coupon.data[c].discount_value,
                    'displayTax': '0.00'
                  }
                })
              }
            }
          }
        }
      } catch (error) {
        console.error('Error generateCartBasic')
      }
      return cart
    },
    /**
     * Load all default messages from GMS and parse error code to appropriate message
     * @param error - Object
     * @returns {string} parsed message
     */
    getMessageFromGms (error) {
      const messages = this.$session.get('messages') || []
      const errorCode = error.error.code
      const lang = this.$session.get('lang')

      const filteredMsg = messages && errorCode ? messages.find(element => element.error_code === errorCode) : undefined
      let message = filteredMsg && filteredMsg.hasOwnProperty('error_message') && filteredMsg.error_message[lang] ? filteredMsg.error_message[lang] : error.error.message

      if (main.$const.GMS_EXCEPTION_CODE.includes(errorCode)) {
        // message = filteredMsg && filteredMsg.error_message[lang] ? filteredMsg.error_message[lang] : message
        const minCart = error.error && error.error.data && error.error.data.min_cart ? error.error.data.min_cart : null
        if (minCart) {
          const formattedMinCart = minCart.replace('.00', '')
          message = message.replace('%@', this.$const.CURRENCY + formattedMinCart )
        } else {
          message = error.error.message
        }
      }

      return message
    },
    eventTrackingLoadCart(vm) {
      console.info('+++++++++++++eventTrackingLoadCart data ++++++++++++++')
      let layer = {
        'event': 'cart.load.auto.dataLayer.load',
        'cart': this.generateCartBasic(vm, true)
      }
      console.info('+++++++++++++eventTrackingLoadCart data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingLoadCart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingFormLoad(form) {
      console.info('+++++++++++++eventTrackingFormLoad ++++++++++++++')
      let data = {
        'event': 'form.load.auto.dataLayer.load',
        'form': {
          'id': form.id,
          'name': form.name,
          'category': form.category,
          'target': form.url
        }
      }
      console.info('+++++++++++++eventTrackingFormLoad data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormLoad end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingFormSubmit(form) {
      console.info('+++++++++++++eventTrackingFormSubmit ++++++++++++++')
      let data = {
        'event': 'form.interact.manual.submit.formSubmit',
        'form': {
          'id': form.id
        }
      }
      console.info('+++++++++++++eventTrackingFormSubmit data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormSubmit end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingPaymentDefault (paymentInfo) {
      console.info('+++++++++++++eventTrackingPaymentDefault ++++++++++++++')
      let data = {
        'event': 'defaultPayment',
        'eventCategory': 'Ecommerce',
        'eventAction': 'EC: payment method',
        'eventLabel': `${paymentInfo.code} - default`,
        'eventValue': undefined
      }
      console.info(data)
      console.info('+++++++++++++eventTrackingPaymentDefault end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingFormSuccess(form) {
      console.info('+++++++++++++eventTrackingFormSuccess ++++++++++++++')
      let data = {
        'event': 'form.load.auto.success.formSuccess',
        'form': {
          'id': form.id
        }
      }
      console.info('+++++++++++++eventTrackingFormSuccess data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormSuccess end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingFormError(form) {
      console.info('+++++++++++++eventTrackingFormError ++++++++++++++')
      let data = {
        'event': 'form.load.auto.error.formError',
        'form': {
          'id': form.id
        },
        'error': {
          'code': form.error.code,
          'type': form.error.type,
          'error': form.error.error
        }
      }
      console.info('+++++++++++++eventTrackingFormError data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormError end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingMoudle(data) {
      let links = []
      for (let i in data) {
        links.push(data[i])
      }
      let layer = {
        assets: {
          links: links
        }
      }
      console.info('+++++++++++++eventTrackingMoudle data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingMoudle end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingModule(data) {
      console.info('+++++++++++++eventTrackingModule data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingModule end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingLoginSuccess(vm) {
      console.info('+++++++++++++eventTrackingLoginSuccess ++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.success.loginSuccess',
        'user': this.getUserDatalayer(vm)
      }
      console.info(layer)
      console.info('+++++++++++++eventTrackingLoginSuccess end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingModuleLoadDeal(vm, group) {
      console.info('+++++++++++++eventTrackingModuleLoadDeal++++++++++++++')
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let items = []
      let products = []
      for (let i in group.items) {
        items.push({
          'id': group.items[i].uuid,
          'type': 'product',
          'position': (parseFloat(i) + 1)
        })
        let variants = []
        let item = group.items[i]
        if (item.first_layers && item.first_layers.length > 0) {
          for (let f in item.first_layers) {
            let price = item.first_layers[f].price
            if (typeof item.first_layers[f].second_layers !== 'undefined' && !vm.empty(item.first_layers[f].second_layers)) {
              for (let s in item.first_layers[f].second_layers) {
                price = item.first_layers[f].price + item.first_layers[f].second_layers[s].price
                variants.push({
                  id: item.first_layers[f].uuid + '-' + item.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name} ${item.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
            } else {
              variants.push({
                id: item.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: price,
                  displayTax: 0
                }
              })
            }
          }
        }
        products.push({
          'id': group.items[i].uuid,
          'name': this.convertStringSnakeCase(group.items[i].name_en || group.items[i].name),
          'category': cateogry.name || '',
          'variants': variants,
          'value': {
            displayGross: group.items[i].price || 0,
            displayTax: 0
          },
          'tax': {
            'type': '',
            'name': '',
            'size': ''
          },
          'purchaseMethod': 'deal',
          'bundleItems': []
        })
      }
      let data = {
        'event': 'module.load.manual.dataLayer.load',
        'modules': [
          {
            'id': group.uuid || '',
            'name': group.name || '',
            'type': 'merchandising',
            'placement': 'item-selection-box',
            'items': items
          }
        ],
        'products': products
      }
      console.info('+++++++++++++eventTrackingModuleLoadDeal data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingModuleLoadDeal end ++++++++++++++')
      dataLayer.push(data)
    },
    // GF20-451 Implement Loyalty Tracking based on design tracking
    eventHutRewardsHeaderLink () {
      console.info('+++++++++++++eventHutRewardsHeaderLink ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.HutRewardsHeader'
      }
      console.info(layer)
      console.info('+++++++++++++eventHutRewardsHeaderLink end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventClickedLogin () {
      console.info('+++++++++++++eventClickedLogin ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.Login'
      }
      console.info(layer)
      console.info('+++++++++++++eventClickedLogin end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventClickedSignUp () {
      console.info('+++++++++++++eventClickedSignUp ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.SignUp'
      }
      console.info(layer)
      console.info('+++++++++++++eventClickedSignUp end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventChangedLanguage (language) {
      console.info('+++++++++++++eventClickedSignUp ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.ChangedLanguage',
        'language': language
      }
      console.info(layer)
      console.info('+++++++++++++eventClickedSignUp end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventHutRewardsMyAccount () {
      console.info('+++++++++++++eventHutRewardsMyAccount ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.loggedin.MyAccount'
      }
      console.info(layer)
      console.info('+++++++++++++eventHutRewardsMyAccount end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventHutRewardsLogout () {
      console.info('+++++++++++++eventHutRewardsLogout ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.loggedin.Logout'
      }
      console.info(layer)
      console.info('+++++++++++++eventHutRewardsLogout end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventSigninStart () {
      console.info('+++++++++++++eventSigninStart ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.signinStart'
      }
      console.info(layer)
      console.info('+++++++++++++eventSigninStart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventRegistrationStart () {
      console.info('+++++++++++++eventRegistrationStart ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.registrationStart'
      }
      console.info(layer)
      console.info('+++++++++++++eventRegistrationStart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventClickedOnRedeemInCart () {
      console.info('+++++++++++++eventClickedOnRedeemInCart ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.clickedOnRedeemInCart'
      }
      console.info(layer)
      console.info('+++++++++++++eventClickedOnRedeemInCart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventRewardItemApplied () {
      console.info('+++++++++++++eventRewardItemApplied ++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.click.rewardItem'
      }
      console.info(layer)
      console.info('+++++++++++++eventRewardItemApplied end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventRewardItemRemoved () {
      console.info('+++++++++++++eventRewardItemRemoved ++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.click.rewardItemRemoved'
      }
      console.info(layer)
      console.info('+++++++++++++eventRewardItemRemoved end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventRewardItemCancel () {
      console.info('+++++++++++++eventRewardItemCancel ++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.click.cancelRemovalOfRewardItem'
      }
      console.info(layer)
      console.info('+++++++++++++eventRewardItemCancel end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingShippingInfo (vm) {
      try {
        console.info('+++++++++++++eventTrackingShippingInfo ++++++++++++++')
        let shipping = 'delivery'
        const orderType = vm.$disposition.getByKey(vm, 'orderType', 'D')
        if (orderType === vm.$const.CARRYOUT) {
          shipping = 'carryout'
        }
        let data = {
          'event': 'cart.interact.auto.dataLayer.shippingInfo',
          'shipping_tier': shipping
        }
        console.info('+++++++++++++eventTrackingShippingInfo data ++++++++++++++')
        console.info(data)
        console.info('+++++++++++++eventTrackingShippingInfo end ++++++++++++++')
        dataLayer.push(data)
      } catch (error) {
        console.error(error)
        console.error('+++++++++++++eventTrackingShippingInfo error ++++++++++++++')
      }
    },
    eventTrackingPaymentMethodSelected (paymentMethod) {
      try {
        console.info('+++++++++++++eventTrackingPaymentMethodSelected ++++++++++++++')
        let data = {
          'event': 'cart.interact.manual.submit.paymentMethodSelected',
          'payment_type': paymentMethod
        }
        console.info('+++++++++++++eventTrackingPaymentMethodSelected data ++++++++++++++')
        console.info(data)
        console.info('+++++++++++++eventTrackingPaymentMethodSelected end ++++++++++++++')
        dataLayer.push(data)
      } catch (error) {
        console.error(error)
        console.error('+++++++++++++eventTrackingPaymentMethodSelected error ++++++++++++++')
      }
    },
    eventTrackingAutoLocalised () {
      try {
        console.info('+++++++++++++eventTrackingAutoLocalised ++++++++++++++')
        let data = {
          'event': 'user.interact.auto.success.auto.localisation'
        }
        console.info('+++++++++++++eventTrackingAutoLocalised data ++++++++++++++')
        console.info(data)
        console.info('+++++++++++++eventTrackingAutoLocalised end ++++++++++++++')
        dataLayer.push(data)
      } catch (error) {
        console.error(error)
        console.error('+++++++++++++eventTrackingAutoLocalised error ++++++++++++++')
      }
    },
    // End GF20-451 Implement Loyalty Tracking based on design tracking
    getProductByUUID(uuid, callback) {
      let vm = this
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }

      orderTime = this.convertSecond(orderTime)

      let data = {
        tier: this.$disposition.getByKey(this, 'tier', '1'),
        order_type: this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        order_time: orderTime,
        outlet_code: this.getOutletCode(this)
      }

      this.axios.getMenuDetails(uuid, data, function (response) {
        if (!response.data.status) {
          if (response.data.error) {
            vm.$notify({
              type: 'error',
              title: response.data.error.message || vm.$t('invalid_item')
            })
          }
          vm.redirectToMenuPage(vm.$route.params.slug)
        } else {
          callback(response.data.data.item, null);
        }
      }, function (error) {
        callback(null, error)
      })
    },
    getProductByNameseo (nameSeo, callback) {
      let vm = this
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }

      orderTime = this.convertSecond(orderTime)

      let data = {
        friendly_seo_name: nameSeo,
        tier: this.$disposition.getByKey(this, 'tier', '1'),
        order_type: this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        order_time: orderTime,
        outlet_code: this.getOutletCode(this)
      }

      this.axios.getComboDetailsFriendlyNameSeo(data, function (response) {
        if (response.data.error) {
          // duplicate friendly name seo
          let uuid = vm.uuidForNameseoDuplicate || nameSeo
          if (response.data.error.code === vm.$const.DUPLICATE_FRIENDLY_NAME_SEO && !vm.uuidForNameseoDuplicate) {
            // redirectToMenuPage
            vm.$notify({
              type: 'Error',
              title: vm.$t('invalid_item')
            })
            let slug = vm.$route.params.slug
            vm.redirectToMenuPage(slug)
          } else vm.getProductByUUID(uuid, callback)
        } else if (!response.data.status) {
          vm.redirectToMenuPage(vm.$route.params.slug)
        } else {
          callback(response.data.data.item, null);
        }
      }, function (error) {
        callback(null, error)
      })
    },
    redirectToMenuPage(slug = null, subSlug = null, uuid = null, isReplace = false) {
      this.$root.$emit(this.$const.EVENT_BUS.REDIRECT_TO_MENU_PAGE, slug, subSlug, uuid, isReplace);
    },
    redirectToPage(array, query){
      let categoryList = this.$session.get('listCategory')
      for (let i in categoryList) {
        if (lodash.includes(array, categoryList[i].slug)) {
          let url = '/order/' + categoryList[i].slug
          if(query && query.callback){
            url = query.callback
          }

          this.$router.push(url)
          return
        }
      }
    },
    callEventBus(eventName, data = null, callback = null) {
      if(eventName){
        this.$bus.$emit(eventName, data, callback)
      }
    },
    callEventListener(eventName, data, callback) {
      this.$root.$emit(eventName, data, callback);
    },
    back() {
      this.$router.back()
    },
    redirectToUrl(url, isRedirect = false, newTab = false, isReplace = false) {
      if (isRedirect) {
        if (newTab) {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      } else {
        if(isReplace){
          this.$router.replace(url)
        }else{
          this.$router.push(url)
        }
      }

      return true
    },
    redirectTo(name, params) {
      this.$router.push({'name': name, 'params': params})
    },
    getCouponImage(item, image = null) {
      if (!image && (!item.image || lodash.isEmpty(item.image))) {
        let lang = this.$i18n ? this.$i18n.locale || this.$const.LANG_JP : this.$const.LANG_JP
        if (!this.empty(lang)) {
          lang = lang.toUpperCase()
        } else {
          lang = this.$const.LANG_JP.toUpperCase()
        }
        if (lodash.includes(this.$const.COUPON_TYPES.DISCOUNT, item.coupon_type_id)) {
          return this.$const.COUPON_IMAGES.DISCOUNT[lang];
        } else if (lodash.includes(this.$const.COUPON_TYPES.FREE_GIFT, item.coupon_type_id)) {
          return this.$const.COUPON_IMAGES.FREE_GIFT[lang];
        } else {
          return this.$const.COUPON_IMAGES.PROMOTION[lang];
        }
      } else {
        return image || item.image.desktop
      }
    },
    setActiveToppingList(extraToppingList, defaultToppingList) {
      //CHECK PER CATEGORY
      for (let ext in extraToppingList) {
        let count = 0;
        for (let def in defaultToppingList) {
          if (extraToppingList[ext].id == defaultToppingList[def].id) {
            count++;
          }

          extraToppingList[ext].isDisable = false
          if (count >= this.$const.TOPPING.MAX_PER_TOPPING) {
            extraToppingList[ext].isDisable = true
            break;
          }
        }
      }

      if (this.$const.TOPPING.MAX_TOPPING) {
        let defaultList = defaultToppingList.filter(topping => {
          return topping.type == this.$const.TOPPING.TYPE_EXTRA
        });

        if (defaultList && defaultList.length >= this.$const.TOPPING.MAX_TOPPING) {
          for (let ext in extraToppingList) {
            if (extraToppingList[ext].type == this.$const.TOPPING.TYPE_EXTRA) {
              extraToppingList[ext].isDisable = true
            }
          }
        }
      }
    },
    convertToKanaName(text, callback) {
      this.axios.apiCustomer.convertKana(text, (response) => {
        callback(null, response.data.data.result)
      }, function (error) {
        callback(true)
      })
    },
    convertSecond(datetime){
      if (!datetime) {
        datetime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      datetime = moment(datetime)
      datetime.set({second : 0})
      return datetime.format('YYYY-MM-DD HH:mm:ss')
    },
    addTimeToClearCache (datetime) {
      if (!datetime) {
        datetime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      datetime = moment(datetime).add(2, 'minutes')

      return datetime.format('YYYY-MM-DD HH:mm:ss')
    },
    getMenuRequest(categoryId = null, subCategoryId = null) {
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      orderTime = this.convertSecond(orderTime)
      let data = {
        'order_time': orderTime,
        'tier': this.$disposition.getByKey(this, 'tier', '1'),
        'order_type': this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
      }

      let outletCode = this.$disposition.getByKey(this, 'outletCode', null)
      if (outletCode) {
        data = {
          'order_time': orderTime,
          'outlet_code': this.$disposition.getByKey(this, 'outletCode', null),
          'tier': this.$disposition.getByKey(this, 'tier', '1'),
          'order_type': this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
        }
      } else if (this.$route.query.isApp === '1') {
        data.order_type = this.$route.query.orderType || data.order_type
        data.outlet_code = this.$route.query.outletCode || data.outlet_code
      }

      if (categoryId) {
        data.category_id = categoryId
      }

      if (subCategoryId) {
        data.sub_category_id = subCategoryId
      }

      return data
    },
    getWaitingTime (vm) {
      let number = 'null'
      let type = vm.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
      let quoctime = vm.$disposition.getByKey(this, 'quoteTime', {})
      if (quoctime && quoctime.hasOwnProperty(type)) {
        number = quoctime[type]
      }
      return number
    },
    setOutletById(vm, outletId, orderType, callback) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, true)
      let data = {
        order_type: orderType.charAt(0),
        order_time: this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
          this.$disposition.getByKey(this, 'collectionTimeValue', '')),
        advance_order: this.$disposition.getByKey(this, 'advanceOrder', 0) || 0,
        outlet_id: outletId
      }

      // Reload Category with up-to-date outlet_code
      vm.callEventBus(vm.$const.EVENT_BUS.LOAD_CATEGORY, true)

      this.axios.apiOutlet.checkOutletAvailable(data,
        function (response) {
          response = response.data
          if (response.status) {
            let data = vm.$disposition.get(vm)
            response = response.data.item
            // set data
            data.lat = response.lat
            data.long = response.long
            data.postalCode = response.zip
            //data.locationName = outletData.kanji_address
            //data.outletAddress = outletData.kanji_address
            data.orderType = orderType
            data.outletId = response.id
            data.outletName = response.name
            data.outletCode = response.code
            data.outletPhone = response.phone
            //data.addressCode = outletData.address_code
            data.advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
            data.tier = response.tier
            data.minCart = response.min_cart
            data.houseNo = ''
            data.landmark = ''
            data.quoteTime = response.quote_time
            data.customize = response.customize || {}
            vm.disposition = data

            let cart = vm.$cart.get(vm)

            if (cart.uuid) {
              vm.$modal.show('dialog', {
                text: vm.$t('confirm.remove_cart'),
                buttons: [
                  {
                    title: vm.$t('button_yes'),
                    handler: () => {
                      vm.proceessDispostion(vm, data, function () {
                        vm.$modal.hide('dialog')
                        vm.redirectToPage(vm.$const.SLUG_LIST.DEAL)
                      })
                    }
                  },
                  {
                    title: vm.$t('button_close')
                  }
                ]
              })
            } else {
              vm.proceessDispostion(vm, data, function () {
                vm.redirectToMenuPage()
              })
            }
          } else if (response.message && response.message != '') {
            vm.$notify({
              type: 'warn',
              title: response.message
            })
          }

          main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
        },
        function (error) {
          error = error.error
          vm.eventTrackingLocalisationError({id: 'error-zip-code', error: 'invalid-zip-code'})
          main.callEventBus(main.$const.EVENT_BUS.LOADING, false)

          let message = vm.$t('modal.advance_order_message')
          if (error.code == vm.$const.LOCALIZATION_CODE.UNAVALIABLE) {
            message = vm.$t('message_find_outlet_empty')
            vm.$modal.show('dialog', {
              text: message,
              buttons: [
                {
                  title: vm.$t('button_close')
                }
              ]
            })
          } else if (error.code == vm.$const.LOCALIZATION_CODE.NOTOPEN) {
            message = vm.$t('localization.notopen')
            vm.$modal.show('dialog', {
              text: message,
              buttons: [
                {
                  title: vm.$t('button_close')
                }
              ]
            })
          } else {
            vm.$modal.show(ASAPPopup, {outletId: outletId, orderType: orderType, hideASAP: 'true', message: message, 'onCheckAvailableHut': 1})

            // vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
            /*vm.$modal.show(ASAPPopup, {
              outletId: outletId,
              orderType: orderType,
              outletDataZip: outletData,
              hideASAP: 'true',
              message: message
            })*/
          }

        }
      )
    },
    getCurrentOrderType() {
      return this.$disposition.getByKey(this, 'orderType', '').toUpperCase()
    },
    proceessDispostion(vm, outlet, callback) {
      if(outlet.addressCode){
        let data = {address_code: outlet.addressCode}
        this.axios.apiOutlet.getAddressByAddressCode(data,
          function (response) {
            response = response.data.data.items
            if (response.length > 0) {
              outlet.prefectureName = response[0].level1
              outlet.cityName = response[0].level2
              outlet.villeageName = response[0].level3
              outlet.st = response[0].level4
            }

            vm.$disposition.set(vm, outlet)
            vm.$session.remove('cart')
            vm.$root.$emit('cartUpdate')
            vm.getPlasticBag(vm)
            callback()
          },
          function (error) {
          }
        )
      }else{
        vm.$disposition.set(vm, outlet)
        vm.$session.remove('cart')
        vm.$root.$emit('cartUpdate')
        vm.getPlasticBag(vm)
        callback()
      }
    },
    setHtmlClass(tagName, className, isRemove = false){
      const element = document.getElementsByTagName(tagName)[0];
      if(className){
        if(isRemove){
          element.className = body.className.replace(`/\b${className}\b/`, '');
        }else{
          element.classList.add(className);
        }
      }
    },
    setHtmlId(tagName, id){
      const element = document.getElementsByTagName(tagName)[0];
      element.id = id;
    },
    getTotalCartItem(cart) {
      let quantity = 0
      if (cart.data) {
        for (let i in cart.data) {
          if(cart.data[i].product_type != constants.PRODUCT_TYPE_CONDIMENT &&
            cart.data[i].product_type != constants.PRODUCT_TYPE_CUTLERRY) {
            quantity += cart.data[i].quantity
          }
        }
      }
      return quantity
    },
    parseQueryString(data) {
      return Object.keys(data).map(function (key) {
        return key + '=' + data[key]
      }).join('&');
    },
    formatDate(date, formatInput, formatOutput){
      return moment(date, formatInput).format(formatOutput)
    },
    getByteLength(string, format = constants.FORMAT_CODE.UTF8){
      if(string){
        if(format == constants.FORMAT_CODE.JIS){
          return string.replace(/[^\x00-\x80｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ ﾞ ﾟ]/g, 'xx').length;
        }else{
          return Buffer.byteLength(string, format);
        }
      }

      return null
    },
    checkValidDateTimeOfCart (vm) {
      let collectionTime = vm.$disposition.getByKey(vm, 'collectionTimeValue', '')
      let advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
      let timezone = vm.$disposition.getByKey(vm, 'timezone', '')
      if (advanceOrder == 0) {
        return true
      }

      let datatime = null
      let now = null
      if (timezone) {
        datatime = moment.tz(collectionTime, timezone)
        now = moment().tz(timezone).format('YYYY-MM-DD HH:mm')
      } else {
        datatime = moment(collectionTime)
        now = moment.format('YYYY-MM-DD HH:mm')
      }
      if (!datatime.isValid()) {
        return true
      }
      if (now > datatime.format('YYYY-MM-DD HH:mm')) {
        return false
      }
      return true
    },
    _setTimeToASAP (vm, timepicker, advanceOrder) {
      let dataObject = vm.$disposition.get(vm)
      dataObject.advanceOrder = advanceOrder
      dataObject.collectionTime = timepicker
      dataObject.collectionTimeText = timepicker.pickedDay + ' ' + timepicker.pickedHours
      let time = timepicker.pickedHours.split(' - ')
      if (time.length > 1) {
        time = time[1]
      } else if (time.length > 0) {
        time = time[0]
      }
      dataObject.collectionTimeValue = timepicker.pickedDay + ' ' + time
      vm.$disposition.set(vm, dataObject)
      vm.$root.$emit('collectionTimeUpdate')
    },
    resetTimeToASAP (vm) {
      var orderType = vm.$disposition.getByKey(vm, 'orderType', 'D')
      let id = vm.$disposition.getByKey(vm, 'outletId', '')
      vm.axios.apiOutlet.getOutletOpeningHours({outletId: id, order_type: orderType.charAt(0), hideFlag: true}, function (response) {
        let items = response.data.data.items
        if (!vm.empty(items)) {
          let timezone = items[0].info.timezone
          let now = moment().tz(timezone)
          let flag = false
          for (let _d in items) {
            let obTime = []
            let date = moment.utc(items[_d].date).tz(timezone)
            let asapVisible = false
            let absolutelyAsap = false
            if (items[_d].info.stop_order != 1 && (date.format('YYYY') > now.format('YYYY') || date.dayOfYear() >= now.dayOfYear())) {
              let dateFormat = date.format('YYYY-MM-DD')
              let info = items[_d].info
              let _originStartTime = vm.convertUTCToTimeZone(dateFormat + ' ' + info.start_time, timezone)
              let startTime = vm.convertUTCToTimeZone(dateFormat + ' ' + info.start_time, timezone)
                .add(info.quote_time, 'minutes')
              let endTime = vm.convertUTCToTimeZone(dateFormat + ' ' + info.end_time, timezone)
              startTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
              _originStartTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
              endTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
              if (endTime.format('HH:mm:ss') == '00:00:00') {
                endTime.set('hour', 23)
                endTime.set('minute', 55)
                endTime.set('second', 0)
              }
              let startTimeOrigin = vm._.cloneDeep(startTime)
              //TODAY
              let nextMinute = null
              let currentTime = moment(moment().tz(timezone).format('YYYY-MM-DD HH:mm'))
              if (now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
                if (now.isAfter(startTime)) {
                  startTime = moment().tz(timezone).add(info.quote_time, 'minutes')
                }
                if (currentTime.isSameOrBefore(endTime) && currentTime.isSameOrAfter(_originStartTime)) {
                  asapVisible = true
                  absolutelyAsap = true
                }
                //check duration
                if (!absolutelyAsap) {
                  let cloneEndtime = vm._.cloneDeep(endTime)
                  let cloneEndtimeDuration = vm.getEndTime(vm, info, cloneEndtime, orderType, timezone)
                  cloneEndtime.hour(cloneEndtimeDuration.get('hour'))
                  cloneEndtime.minute(cloneEndtimeDuration.get('minute'))
                  if (currentTime.isSameOrBefore(cloneEndtime)) {
                    asapVisible = true
                  }
                }
              }
              let intervalValue = vm.getInterval(vm, info, startTime, orderType, timezone)
              if (intervalValue != null) {
                if (intervalValue == -1) {
                  intervalValue = info.interval
                }
              } else {
                intervalValue = info.interval
              }

              if (now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
                nextMinute = intervalValue * (Math.floor(startTime.get('minute') / intervalValue))
                // eslint-disable-next-line no-unmodified-loop-condition
                while (nextMinute < startTime.get('minute') && intervalValue > 0) {
                  nextMinute += intervalValue
                }
                startTime.minute(nextMinute)
              }

              if (absolutelyAsap) {
                asapVisible = true
              } else if (asapVisible && !startTime.isSameOrBefore(currentTime)) {
                asapVisible = false
              }
              while (startTime.isSameOrBefore(endTime)) {
                let currentFormat = startTime.format('HH:mm')
                let interval = vm.getInterval(vm, info, startTime, orderType, timezone)
                let isAdd = true
                if (interval != null) {
                  if (interval == -1) {
                    isAdd = false
                    interval = info.interval
                  }
                } else {
                  interval = info.interval
                }
                // expired time (eg: 23:45 - 00:00)
                let nextTime = vm._.cloneDeep(startTime)
                nextTime.add(interval, 'minutes')
                if (nextTime.format('YYYY-MM-DD HH:mm') > endTime.format('YYYY-MM-DD HH:mm')) {
                  isAdd = false
                }
                // end expired time
                startTime = startTime.add(interval, 'minutes')
                if (isAdd) {
                  if (orderType == vm.$const.CARRYOUT) {
                    obTime.push(currentFormat)
                  } else {
                    let format = currentFormat + ' - ' + startTime.format('HH:mm')
                    obTime.push(format)
                  }
                }
              }
              if (!vm.empty(obTime) || asapVisible) {
                let timepicker = ''
                let advanceOrder = 0
                if (dateFormat == now.format('YYYY-MM-DD')) {
                  let time = moment.tz(timezone).format('HH:mm')
                  let timestart = startTimeOrigin.format('HH:mm')
                  if (time >= timestart || asapVisible) {
                    timepicker = {'pickedDay': dateFormat, 'pickedHours': vm.$t('asap')}
                  } else {
                    timepicker = {'pickedDay': dateFormat, 'pickedHours': obTime[0]}
                    advanceOrder = 1
                  }
                } else {
                  timepicker = {'pickedDay': dateFormat, 'pickedHours': obTime[0]}
                  advanceOrder = 1
                }
                vm._setTimeToASAP(vm, timepicker, advanceOrder)
                flag = true
                break
              }
            }
          }
          if (!flag) {
            let timepicker = {'pickedDay': moment().format('YYYY-MM-DD'), 'pickedHours': vm.$t('asap')}
            vm._setTimeToASAP(vm, timepicker, 0)
          }
        } else {
          let timepicker = {'pickedDay': moment().format('YYYY-MM-DD'), 'pickedHours': vm.$t('asap')}
          vm._setTimeToASAP(vm, timepicker, 0)
        }
        // eslint-disable-next-line handle-callback-err
      }, function (error) {
        let timepicker = {'pickedDay': moment().format('YYYY-MM-DD'), 'pickedHours': vm.$t('asap')}
        vm._setTimeToASAP(vm, timepicker, 0)
      })
    },
    getInterval(vm, data, currentTime, orderType, timezone) {
      let interval = null
      if (data.advance_duration && data.advance_duration.length) {
        for (let i in data.advance_duration) {
          let item = data.advance_duration[i]
          let date = moment.utc(item.date).tz(timezone)
          let closeTime = vm.convertUTCToTimeZone(item.date + ' ' + item.closing, timezone)
          let openTime = vm.convertUTCToTimeZone(item.date + ' ' + item.opening, timezone)
          closeTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          openTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))

          if (closeTime.format('HH:mm:ss') == '00:00:00') {
            closeTime.set('hour', 23)
            closeTime.set('minute', 55)
            closeTime.set('second', 0)
          }
          if (currentTime.isSameOrAfter(openTime) && currentTime.isBefore(closeTime)) {
            if (orderType == vm.$const.DELIVERY) {
              interval = item.duration.D
            } else {
              interval = item.duration.C
            }
            break
          }
        }
      }
      return interval
    },
    getEndTime (vm, data, endTime, orderType, timezone) {
      let cloneEndTime = vm._.cloneDeep(endTime)
      let interval = null
      let closing = moment(cloneEndTime.format('HH:mm:ss'), 'HH:mm:ss')
      if (data.advance_duration && data.advance_duration.length) {
        for (let i in data.advance_duration) {
          let item = data.advance_duration[i]
          let date = moment.utc(item.date).tz(timezone)
          let newClosing = moment.utc(item.closing, 'HH:mm:ss').tz(timezone)
          newClosing.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          if (newClosing.format('HH:mm:ss') == '00:00:00') {
            newClosing.set('hour', 23)
            newClosing.set('minute', 55)
            newClosing.set('second', 0)
          }
          if (moment(closing.format('YYYY-MM-DD HH:mm:ss')).isSameOrBefore(newClosing.format('YYYY-MM-DD HH:mm:ss'))) {
            if (orderType == vm.$const.DELIVERY) {
              interval = item.duration.D
            } else {
              interval = item.duration.C
            }
            if (interval == -1) {
              closing = moment.utc(item.opening, 'HH:mm:ss').tz(timezone)
              closing.year(date.get('year')).month(date.get('month')).date(date.get('date'))
            }
            break
          }
        }
      }
      return closing
    },
    isShowDealAndPrice (vm) {
      if (this.checkPosition(vm)) {
        return true
      }
      if (vm.$route.query.hasOwnProperty('landing') && vm.$route.query.landing == 1) {
        document.cookie = 'landingShow=1; path=/;max-age=' + 30 * 24 * 60 * 60 * 1000
        return true
      }

      return this.getCookie('landingShow') != ''
    },
    getCookie (cname) {
      let name = cname + '='
      let decodedCookie = decodeURIComponent(document.cookie)
      let ca = decodedCookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    isPizzaItem (item, isCombo = false) {
      if (isCombo) {
        return item.first_layers.length > 0
      } else {
        return lodash.has(item, 'first_layers') && !lodash.isNil(item.first_layers)
      }
    },
    groupBy (objArr, attr) {
      return objArr.reduce((accObj, item) => {
        const key = item[attr]
        if (!accObj[key]) {
          accObj[key] = []
        }

        accObj[key].push(item)

        return accObj
      }, {})
    },
    isExpiredDate(date, amount = 0) {
      let orderTime = moment.utc(date).local()
      let today = moment()
      if (today.diff(orderTime, 'days') >= amount) {
        return true
      }
      return false
    },
    setCookiePaymentMethod (vm, data = []) {
      let outletCode = vm.$disposition.getByKey(vm, 'outletCode', null)
      let orderTime = vm.convertSecond(vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''), vm.$disposition.getByKey(vm, 'collectionTimeValue', '')))
      orderTime = orderTime.replace(' ', '-')

      let keyPayment = 'list_payment_method-' + outletCode + '-' + orderTime
      let oldkey = vm.$cookie.get('key_payment_method')

      if (oldkey && oldkey != keyPayment) {
        vm.$cookie.delete(oldkey)
      }
      vm.$cookie.set('key_payment_method', keyPayment, {
        expires: '10min'
      })
      vm.$cookie.set(keyPayment, btoa(escape(JSON.stringify(data))), {
        expires: '10min'
      })
    },
    getPaymentMethodFromCookie (vm) {
      let outletCode = vm.$disposition.getByKey(vm, 'outletCode', null)
      let orderTime = vm.convertSecond(vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''), vm.$disposition.getByKey(vm, 'collectionTimeValue', '')))
      orderTime = orderTime.replace(' ', '-')

      let keyPayment = 'list_payment_method-' + outletCode + '-' + orderTime
      let oldkey = vm.$cookie.get('key_payment_method')

      if (oldkey && oldkey != keyPayment) {
        vm.$cookie.delete(oldkey)
        return false
      }

      if (oldkey) {
        let payments = vm.$cookie.get(oldkey)
        return payments ? JSON.parse(unescape(atob(payments))) : false
      }
      return false
    },
    takeCommonValue (array1, array2) {
      return array1.filter(value => -1 !== array2.indexOf(value))
    },
    getTextInErrorMessage (code) {
      let result = ''
      const messages = this.$session.get('messages')
      const lang = this.$session.get('lang')
      if (messages && messages.length > 0) {
        messages.forEach(item => {
          if (item.error_code === code && item.active === 1) {
            result = item.error_message ? item.error_message[lang] : ''
          }
        })
      }
      return result
    },
    getTelemetryHeader () {
      try {
        if (bmak) {
          return bmak.get_telemetry()
        }
      } catch (error) {
        console.log(error)
      }
      return null
    },
    evenTrackingNotInDeliveryZone(address, lat = '', lng = ''){
      console.info("+++++++++++++++++evenTrackingNotInDeliveryZone+++++++++++++++")
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Not in Delivery Zone',
        'eventLabel': 'Address: '+ address + '. latlong: ' + lat + ', ' + lng,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++evenTrackingNotInDeliveryZone data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++evenTrackingNotInDeliveryZone end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingDeliveryDeadZone(statusAvailable) {
      console.info("+++++++++++++++++eventTrackingDeliveryDeadZone+++++++++++++++")
      let collectionStatus = 'UnAvailable'
      if(statusAvailable == 'UnAvailable')
        collectionStatus = 'Available'
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Delivery Deadzone',
        'eventLabel': 'Collection ' + collectionStatus,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++eventTrackingDeliveryDeadZone data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingDeliveryDeadZone end ++++++++++++++')
      dataLayer.push(data)
    },
    evenTrackingHutIsBouncing(hutID){
      console.info("+++++++++++++++++evenTrackingHutIsBouncing+++++++++++++++")
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Hut is Bouncing',
        'eventLabel': 'Hut ID: '+ hutID,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++evenTrackingHutIsBouncing data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++evenTrackingHutIsBouncing end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingHutClosed(hutID) {
      console.info("+++++++++++++++++eventTrackingHutClosed+++++++++++++++")
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Hut Closed',
        'eventLabel': 'Hut ID: ' + hutID,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++eventTrackingHutClosed data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingHutClosed end ++++++++++++++')
      dataLayer.push(data)
    },
    checkValue (value) {
      if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
        return false
      }
      return true
    },
    getValueFromAttr (item, attr, defaultValue) {
      if (!this.checkValue(item) || !this.checkValue(attr)) {
        return defaultValue
      }
      if (attr.indexOf('.') > -1) {
        const arrs = attr.split('.')
        let result = item
        for (let i = 0; i < arrs.length; i++) {
          result = result[arrs[i]]
          if (!this.checkValue(result)) {
            return defaultValue
          }
        }
        return result
      }
      if (!this.checkValue(item[attr])) {
        return defaultValue
      }
      return item[attr]
    },
    getArrsInArrs (value, data, attr) {
      const vm = this
      if (!this.checkValue(data) || !this.checkValue(attr)) {
        return []
      }
      const arrs = data.filter(function (item) {
        return vm.getValueFromAttr(item, attr) === value
      })
      return arrs
    },
    sortData (data, attr) {
      const result = data.sort(function (a, b) {
        if (a[attr] < b[attr]) return -1
        if (a[attr] > b[attr]) return 1
        return 0
      })
      return result
    },
    sortDescData (data, attr) {
      const result = data.sort(function (a, b) {
        if (b[attr] < a[attr]) return -1
        if (b[attr] > a[attr]) return 1
        return 0
      })
      return result
    },
    setCacheLocalStorage (key, data, expireAmount = 5, expireUnit = 'minutes') {
      let now = moment()
      let dataStorage = {
        data: [],
        expired: null
      }
      if (data) {
        dataStorage.data = data
        dataStorage.expired = now
          .add(expireAmount, expireUnit)
          .format('YYYY-MM-DD HH:mm:ss')
        localStorage[key] = JSON.stringify(dataStorage)
      }
    },
    getCacheLocalStorage (key) {
      let now = moment()
      let data = null
      let isExpired = false
      if (localStorage[key]) {
        let cachedData = JSON.parse(localStorage[key])
        let expired = moment(cachedData.expired, 'YYYY-MM-DD HH:mm:ss')
        if (now.isAfter(expired)) {
          isExpired = true
          localStorage.removeItem(key)
        } else {
          data = cachedData.data
        }
      } else {
        isExpired = true
      }
      return {
        expired: isExpired,
        data: data
      }
    },
    initABTesting (vm, method) {
      try {
        const DEFAULT_CONFIG_AB_TESTING = {
          environment: 'browser',
          storage: 'localStorage',
          storagePrefix: 'test',
          onSetExperiment: (data) => {
            if (data.experimentGoal === 'A/A') {
              return
            }
            vm.sendEventGA(vm, data.experimentGoal, data.experimentName, data.experimentName + '_' + data.variantTitle, null, true)
            vm.eventTrackingExperiments(vm.$const.AB_TESTING_FUNCTIONAL)
          }
        }
        setupExperiments(method, DEFAULT_CONFIG_AB_TESTING)
      } catch (error) {
        console.log(`Error function initABTesting ${error}`)
      }
    },
    sendEventGA (vm, category, action, label, value, nonInteraction) {
      try {
        const payload = {
          eventCategory: category,
          eventAction: action,
          eventLabel: label,
          eventValue: value,
          nonInteraction: nonInteraction
        }
        console.log('payload', payload)
        vm.$ga.event(payload)
      } catch (error) {
        console.log(`Error function sendEventGA ${error}`)
      }
    },
    eventTrackingExperiments (experiments) {
      console.info('+++++++++++++eventTrackingExperiments start ++++++++++++++')
      let data = {
        'event': 'user.interact.auto.experiments',
        'experiments': experiments
      }
      console.info('+++++++++++++eventTrackingExperiments data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingExperiments end ++++++++++++++')
      dataLayer.push(data)
    },
    getValueExperiment (testingName,experiment) {
      for(let i of constants.AB_TESTING_FUNCTIONAL) {
        if(i && i.name && i.name === testingName) {
          for(let v of i.variants) {
            if(v.title === experiment) { return v.value}
          }
        }
      }
    },
    setDataTimeSlot(vm,data,timezone) {
      let responseData = {}
      let openingDateTime = {}
      let defaultDate = vm.$disposition.getByKey(vm, 'collectionTime', '')
      let order_type = vm.orderType || this.$disposition.getByKey(vm, 'orderType', 'D').charAt(0)
      let now = moment().tz(timezone)
      let tomorrow = moment().tz(timezone).add(1, 'days')

      for (let _d in data) {
        let obTime = []
        let date = moment.utc(data[_d].date).tz(timezone)
        let asapVisible = false
        let absolutelyAsap = false
        if (data[_d].info.stop_order != 1 && (date.format('YYYY') > now.format('YYYY') || date.dayOfYear() >= now.dayOfYear())) {
          let dateFormat = date.format('YYYY-MM-DD')
          let info = data[_d].info
          let _originStartTime = this.convertUTCToTimeZone(dateFormat + ' ' + info.start_time, timezone)
          let startTime = this.convertUTCToTimeZone(dateFormat + ' ' + info.start_time, timezone)
                              .add(info.quote_time, 'minutes')
          let endTime = this.convertUTCToTimeZone(dateFormat + ' ' + info.end_time, timezone)

          startTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          _originStartTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          endTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          if (endTime.format('HH:mm:ss') == '00:00:00') {
            endTime.set('hour', 23)
            endTime.set('minute', 55)
            endTime.set('second', 0)
          }
          let startTimeOrigin = lodash.cloneDeep(startTime)

          //TODAY
          // let nextMinute = null
          let currentTime = moment(moment().tz(timezone).format('YYYY-MM-DD HH:mm'))
          if (now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
            // if (now.isAfter(startTime)) {
            //   startTime = moment().tz(vm.timezone).add(info.quote_time, 'minutes')
            // }

            if (currentTime.isSameOrBefore(endTime) && currentTime.isSameOrAfter(_originStartTime)) {
              asapVisible = true
              absolutelyAsap = true
            }
            //check duration
            if (!absolutelyAsap) {
              let cloneEndtime = lodash.cloneDeep(endTime)
              let cloneEndtimeDuration = this.getEndTime(vm,info, cloneEndtime, order_type,timezone)
              cloneEndtime.hour(cloneEndtimeDuration.get('hour'))
              cloneEndtime.minute(cloneEndtimeDuration.get('minute'))
              if (currentTime.isSameOrBefore(cloneEndtime) && currentTime.isSameOrAfter(_originStartTime)) {
                asapVisible = true
              }
            }
          }
          let intervalValue = vm.getInterval(info, startTime, order_type)
          if (intervalValue != null) {
            if (intervalValue == -1) {
              intervalValue = info.interval
            }
          } else {
            intervalValue = info.interval
          }
          const checkNextTime = currentTime.minute(currentTime.get('minute') + info.quote_time + intervalValue)
          while (startTime.isSameOrBefore(endTime)) {
            let currentFormat = startTime.format('HH:mm')
            let interval = vm.getInterval(info, startTime, order_type)
            let isAdd = true

            // Check today time
            if (now.format('YYYY-MM-DD') === date.format('YYYY-MM-DD') &&
              (startTime.get('hour') * 60 + startTime.get('minute') < checkNextTime.get('hour') * 60 + checkNextTime.get('minute'))) {
              isAdd = false
            }

            if (interval != null) {
              if (interval == -1) {
                isAdd = false
                interval = info.interval
              }
            } else {
              interval = info.interval
            }

            // expired time (eg: 23:45 - 00:00)
            let nextTime = lodash.cloneDeep(startTime)
            nextTime.add(interval, 'minutes')
            if (nextTime.format('YYYY-MM-DD HH:mm') > endTime.format('YYYY-MM-DD HH:mm')) {
              isAdd = false
            }
            // end expired time

            startTime = startTime.add(interval, 'minutes')

            if (isAdd) {
              if (order_type == vm.$const.CARRYOUT) {
                obTime.push(currentFormat)
              } else {
                let format = currentFormat + ' - ' + startTime.format('HH:mm');
                obTime.push(format)
              }
            }
          }

          if (!this.empty(obTime) || asapVisible) {
            let result = {}
            result = this.setDateTimeTimeSlot(vm,
                dateFormat,
                obTime,
                now.format('YYYY-MM-DD'),
                tomorrow.format('YYYY-MM-DD'),
                startTimeOrigin,
                asapVisible,
                info.name,
                info.quote_time,
                timezone
                )
            openingDateTime = Object.assign(openingDateTime, result)
          }
        }
      }

      let flag = false
      responseData.openingDateTime = openingDateTime
      if (vm.$disposition.getByKey(vm, 'advanceOrder', '') == 1) {
        for (let date in openingDateTime) {
          if (date == defaultDate.pickedDay) {
            responseData.choiceDay = defaultDate.pickedDay
            responseData.hours = openingDateTime[date].data
            if (_.indexOf(openingDateTime[date].data, defaultDate.pickedHours) >= 0) {
              responseData.choiceHour = defaultDate.pickedHours
            } else {
              responseData.choiceHour = openingDateTime[date].data[0]
            }
            flag = true
            break
          }
        }
      }


      if (!flag) {
        for (let date in openingDateTime) {
          responseData.choiceDay = date
          responseData.hours = openingDateTime[date].data
          responseData.choiceHour = openingDateTime[date].data[0]
          flag = true
          break
        }
      }

      return responseData
    },
    setDateTimeTimeSlot(vm,obDate, obTime, today, tomorrow, startTimeOrigin, asapVisible, holiday, quoteTime ,timezone) {
      let openingDateTime = {}
      let label = ''
      if(obDate == today){
        label = vm.$t('today')
      }else if(obDate == tomorrow){
        label = vm.$t('tomorrow')
      }else {
        let arrarys = obDate.split('-')
        label = arrarys['1'] + '-' + arrarys['2']
      }
       if (holiday && holiday != '') {
         label += ' (' + holiday + ')'
       }

      if (!openingDateTime[obDate]) {
        openingDateTime[obDate] = {'label': label, 'data': obTime, 'quoteTime': quoteTime}
      } else {
        let oldData = openingDateTime[obDate].data
        let newData = obTime
        openingDateTime[obDate].data = oldData.concat(newData)
				openingDateTime[obDate].quoteTime = quoteTime
      }

      if (obDate == today) {
        // check hide asap when asap time not available to order
        let time = moment.tz(timezone).format('HH:mm')
        let timestart = startTimeOrigin.format('HH:mm')
        if (time >= timestart || asapVisible) {
          openingDateTime[obDate].data.unshift(vm.$t('asap'))
        }
      }

      if (openingDateTime[obDate].data.length <= 0) {
        delete openingDateTime[obDate]
      }
      return openingDateTime
    },
    convertTotalPriceToSlice(vm, total) {
      let more = total % vm.$const.SLICE_DEFAULT
      let slice = Math.floor(total/vm.$const.SLICE_DEFAULT)
      return { current: slice, addMore: vm.$const.SLICE_DEFAULT - more }
    },

    getRankInfoUser (rank) {
      let currentRank = null
      if (rank === 1) {
        currentRank = {
          classRank: 'rank-vip',
          iconRank: 'https://static.phdvasia.com/jp/hut-rewards/vip_active.png',
          subIconRank: 'https://static.phdvasia.com/jp/hut-rewards/icon_vip.png'
        }
      } else if (rank === 2) {
        currentRank = {
          classRank: 'rank-gold',
          iconRank: 'https://static.phdvasia.com/jp/hut-rewards/gold_active.png',
          subIconRank: 'https://static.phdvasia.com/jp/hut-rewards/icon_vip.png'
        }
      } else if (rank === 3) {
        currentRank = {
          classRank: 'rank-silver',
          iconRank: 'https://static.phdvasia.com/jp/hut-rewards/silver_active.png',
          subIconRank: 'https://static.phdvasia.com/jp/hut-rewards/icon_gold.png'
        }
      } else if (rank === 4 || rank === 5 || rank === 6) {
        currentRank = {
          classRank: 'rank-member',
          iconRank: 'https://static.phdvasia.com/jp/hut-rewards/member_active.png',
          subIconRank: 'https://static.phdvasia.com/jp/hut-rewards/icon_silver.png'
        }
      } else {
        currentRank = {
          classRank: '',
          iconRank: '',
          subIconRank: ''
        }
      }
      return currentRank
    },
    checkMaintainanceHutReward (startTime, endTime) {
      if (!startTime || !endTime) {
        return false
      }
      const today = moment().tz(TIMEZONE).format('HH:mm:ss')
      const arrsToday = today.split(':')
      const timeToday = Number(arrsToday[0]) * 3600 + Number(arrsToday[1]) * 60 + Number(arrsToday[2])
      const arrsStart = startTime.split(':')
      const timeStart = Number(arrsStart[0]) * 3600 + Number(arrsStart[1]) * 60 + Number(arrsStart[2])
      const arrsEnd = endTime.split(':')
      const timeEnd = (Number(arrsEnd[0]) < Number(arrsStart[0]) ? (Number(arrsEnd[0]) + 24) : Number(arrsEnd[0])) * 3600 + Number(arrsEnd[1]) * 60 + Number(arrsEnd[2])
      if (timeToday >= timeStart && timeToday <= timeEnd) {
        return true
      }
      return false
    },
    getStringIgnoreHTTMLTag (value) {
      return value.replace(/<(?:.|\n)*?>/gm, '')
    },
    getCurrentCategoryNameByCategoryList() {
      let cateogry = {}
      let categoryUuid = this.$session.get('categoryUuid') || this.$store.getters.category_uuid
      let categories = this.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      return cateogry
    },
    getNameCategoryCurrent (menu) {
      let categogry = this.getCurrentCategoryNameByCategoryList()
      let categoryEn = menu.display_categories ? menu.display_categories[0] : ''
      if (menu.isHalf) {
        categoryEn = categogry
      }
      
      categoryEn = (categoryEn && categoryEn.name_en) ? categoryEn.name_en.toLowerCase() : ''
      return categoryEn ? categoryEn.replace(/\s/g, "") : ''
    },
    getNameCategoryFromCart (cartItem) {
      return cartItem.selected_category_name_en ? cartItem.selected_category_name_en.toLowerCase().replace(/\s/g, "") : ''
    },
    getPlasticBag(vm) {
      let orderTime = vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''),
      vm.$disposition.getByKey(vm, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      let params = {
        'order_type': vm.$disposition.getByKey(vm, 'orderType', '').charAt(0),
        'order_time': orderTime,
        'outlet_code': vm.$disposition.getByKey(vm, 'outletCode', ''),
        'type': vm.$const.CARD_ITEM_TYPE.BAG,
        'tier': vm.$disposition.getByKey(vm, 'tier', ''),
        'single_type': 1
      }
      vm.axios.apiMenu.getPlasticBag(params, function (response) {
        let item = response.data.data.items && response.data.data.items[0]
        if (!item) {
          vm.$session.set('plasticBags', null)
        } else {
          vm.$session.set('plasticBags', item)
        }
      })
    },
    openAppOnlyDeal (link) {
      const vm = this
      if (vm.isMobileApp()) {
        window.open(link)
      } else {
        vm.$modal.show(PopupNotifyHut, {
          title: vm.$t('msg_title_app_only_deal'),
          text: vm.$t('msg_content_app_only_deal'),
          alignTitle: 'center',
          btnTitleAction: vm.$t('button_close'),
          fncAction: () => {},
        },
        {
          class: 'modal-hut-notify', transition: 'nice-modal-fade', overlayTransition: 'overlay-fade', clickToClose: false
        })
      }
    },
    sumOfHutRewardInCart (cart) {
      let sum = 0
      let itemCart = (cart.data && cart.data.length > 0) ? cart.data : []
      let ItemHutInCart = itemCart.filter((itemh) => itemh.menu_type === constants.CARD_ITEM_TYPE.FREE)
      if (ItemHutInCart && ItemHutInCart.length > 0) {
        for (let i = 0; i < ItemHutInCart.length; i++) {
          const hut = ItemHutInCart[i]
          sum += hut.quantity
        }
      }
      return sum
    },
    eventLocalisationStart () {
      console.info('+++++++++++++eventLocalisationStart ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.localisationStart'
      }
      console.info(layer)
      console.info('+++++++++++++eventLocalisationStart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventLocalisationSwitch () {
      console.info('+++++++++++++eventLocalisationSwitch ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.localisationSwitch'
      }
      console.info(layer)
      console.info('+++++++++++++eventLocalisationSwitch end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventFindMyLocation () {
      console.info('+++++++++++++eventFindMyLocation ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.findMyLocation'
      }
      console.info(layer)
      console.info('+++++++++++++eventFindMyLocation end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventLoginByGoogle () {
      console.info('+++++++++++++eventLoginByGoogle ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.loginStart',
        'method': 'google'
      }
      console.info(layer)
      console.info('+++++++++++++eventLoginByGoogle end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventLoginByGoogleSuccess () {
      console.info('+++++++++++++eventLoginByGoogleSuccess ++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.success.loginSuccess',
        'method': 'google'
      }
      console.info(layer)
      console.info('+++++++++++++eventLoginByGoogleSuccess end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingAttributeFilter (categoryName, paramFilter) {
      console.log('+++++++++++++ eventTrackingAttributeFilter ++++++++++++++');
      let data = {
        'event': 'user.interact.manual.click.addMenuFilter',
        'filter': paramFilter || '',
        'context': categoryName || ''
      }
      dataLayer.push(data)
    },
    eventTrackingClearAttributeFilter (categoryName) {
      console.log('+++++++++++++ eventTrackingClearAttributeFilter ++++++++++++++');
      let data = {
        'event': 'user.interact.manual.click.clearMenuFilter',
        'context': categoryName || ''
      }
      dataLayer.push(data)
    },
    eventTrackingApplyAttributeFilter (categoryName, paramFilter) {
      console.log('+++++++++++++ eventTrackingApplyAttributeFilter ++++++++++++++');
      let data = {
        'event': 'user.interact.manual.click.addMenuFilter',
        'filter': paramFilter || '',
        'context': categoryName || ''
      }
      dataLayer.push(data)
    },
    eventTrackingSelectAttributeFilterDropdown () {
      console.log('+++++++++++++ eventTrackingSelectAttributeFilterDropdown ++++++++++++++');
      let data = {
        'event': 'user.interact.manual.click.selectMenuFilterDropdown'
      }
      dataLayer.push(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js